// 이 파일은 자동 생성됩니다. 직접 수정하지 말고 원본 엑셀을 고친 뒤 다시 생성하세요.
// 원본: 2026_AI리터리시_본검사_결과지로직_v1.1.xlsx
// 생성: python3 scripts/gen-literacy-2026-data.py [엑셀경로]  (openpyxl 필요)
//
// sch_lev: 'e'(초) | 'm'(중) | 'h'(고)  /  code: 'a' 기술 | 'b' 활용 | 'c' 윤리 | 'd' 인간중심 AI 설계
/* eslint-disable */
export const AREA_CODES = [
  "a",
  "b",
  "c",
  "d"
];

export const AREA_NAMES = [
  "AI·디지털 기술",
  "AI·디지털 활용",
  "AI·디지털 윤리",
  "인간중심 AI 설계"
];

export const OVERVIEW = {
  "definition": "‘AI·디지털 리터러시’란 일상생활과 교과학습에 기반이 되는 기초소양으로서 AI·디지털 기술에 대한 기본 지식과 이해를 바탕으로 윤리적이고 비판적으로 AI·디지털 기술을 활용하고, 창의적이고 주체적으로 AI와 협업하여 자신과 사회의  문제를 해결할 수 있는 역량을 뜻합니다.",
  "purpose": "서울 학생 AI·디지털 리터러시 진단 검사는 학생의 AI·디지털 리터러시 수준을 진단하여 맞춤형 정보를 제공하고, AI·디지털 학습 환경 적응을 위한 맞춤 지원을 하는 것을 목적으로 합니다.",
  "areaDesc": {
    "AI·디지털 기술": "인공지능(AI)의 정의, 기계학습과 생성형 AI의 특징과 주요원리를 이해하고, AI 기술에 흥미와 관심을 갖고 탐구하는 태도를 실천함.",
    "AI·디지털 활용": "문제 해결, 콘텐츠 창작, 학습 및 탐구 등 다양한 목적을 위해 AI·디지털 도구를 적절히 활용하고, AI의 결과를 비판적으로 검토하며 올바른 활용습관을 실천함.",
    "AI·디지털 윤리": "AI의 사회적 영향과 윤리적 문제를 이해하고, AI·디지털 기술을 주체적이고 책임감 있게 사용하여 개인과 타인의 안전을 보호하는 태도를 갖고 실천함.",
    "인간중심 AI 설계": "지속 가능한 발전을 위해 인간의 가치와 목적에 부합하는 AI 시스템을 설계하고, 의사결정의 주도권을 유지하며 AI와 효과적인 협업 전략을 탐색하는 태도를 갖고 실천함."
  },
  "subAreas": [
    [
      "AI·디지털 기술",
      "AI 기본 개념"
    ],
    [
      "AI·디지털 기술",
      "데이터와 기계학습"
    ],
    [
      "AI·디지털 기술",
      "생성형 AI"
    ],
    [
      "AI·디지털 활용",
      "문제 해결"
    ],
    [
      "AI·디지털 활용",
      "창작"
    ],
    [
      "AI·디지털 활용",
      "학습 및 탐구"
    ],
    [
      "AI·디지털 윤리",
      "주체적인 사용"
    ],
    [
      "AI·디지털 윤리",
      "책임감 있는 사용"
    ],
    [
      "AI·디지털 윤리",
      "사회적 영향"
    ],
    [
      "인간중심 AI 설계",
      "공동선을 위한 AI"
    ],
    [
      "인간중심 AI 설계",
      "인간과 AI의 협업"
    ]
  ]
};

export const SUB_AREA_LEVELS = {
  "e": {
    "a": {
      "name": "AI·디지털 기술",
      "high": 8,
      "mid": 4,
      "low": 0,
      "scores": [
        10,
        8,
        5,
        3,
        1,
        0
      ]
    },
    "b": {
      "name": "AI·디지털 활용",
      "high": 5,
      "mid": 3,
      "low": 0,
      "scores": [
        7,
        6,
        4,
        2,
        1,
        0
      ]
    },
    "c": {
      "name": "AI·디지털 윤리",
      "high": 5,
      "mid": 2,
      "low": 0,
      "scores": [
        6,
        5,
        3,
        2,
        1,
        0
      ]
    },
    "d": {
      "name": "인간중심 AI 설계",
      "high": 4,
      "mid": 2,
      "low": 0,
      "scores": [
        5,
        4,
        3,
        2,
        1,
        0
      ]
    }
  },
  "m": {
    "a": {
      "name": "AI·디지털 기술",
      "high": 6,
      "mid": 3,
      "low": 0,
      "scores": [
        8,
        7,
        5,
        3,
        1,
        0
      ]
    },
    "b": {
      "name": "AI·디지털 활용",
      "high": 5,
      "mid": 3,
      "low": 0,
      "scores": [
        7,
        6,
        4,
        2,
        1,
        0
      ]
    },
    "c": {
      "name": "AI·디지털 윤리",
      "high": 5,
      "mid": 3,
      "low": 0,
      "scores": [
        7,
        6,
        4,
        2,
        1,
        0
      ]
    },
    "d": {
      "name": "인간중심 AI 설계",
      "high": 3,
      "mid": 1,
      "low": 0,
      "scores": [
        4,
        null,
        2,
        null,
        1,
        0
      ]
    }
  },
  "h": {
    "a": {
      "name": "AI·디지털 기술",
      "high": 7,
      "mid": 4,
      "low": 0,
      "scores": [
        9,
        7,
        5,
        3,
        1,
        0
      ]
    },
    "b": {
      "name": "AI·디지털 활용",
      "high": 5,
      "mid": 2,
      "low": 0,
      "scores": [
        6,
        5,
        3,
        2,
        1,
        0
      ]
    },
    "c": {
      "name": "AI·디지털 윤리",
      "high": 5,
      "mid": 2,
      "low": 0,
      "scores": [
        6,
        5,
        3,
        2,
        1,
        0
      ]
    },
    "d": {
      "name": "인간중심 AI 설계",
      "high": 3,
      "mid": 1,
      "low": 0,
      "scores": [
        4,
        null,
        2,
        null,
        1,
        0
      ]
    }
  }
};

export const DETAIL_AREAS = {
  "e": [
    {
      "code": "a",
      "subcode": 1,
      "name": "AI 기본 개념"
    },
    {
      "code": "a",
      "subcode": 2,
      "name": "데이터와 기계학습"
    },
    {
      "code": "a",
      "subcode": 3,
      "name": "생성형 AI"
    },
    {
      "code": "b",
      "subcode": 4,
      "name": "문제 해결"
    },
    {
      "code": "b",
      "subcode": 5,
      "name": "창작"
    },
    {
      "code": "b",
      "subcode": 6,
      "name": "학습 및 탐구"
    },
    {
      "code": "c",
      "subcode": 7,
      "name": "주체적인 사용"
    },
    {
      "code": "c",
      "subcode": 8,
      "name": "책임감 있는 사용"
    },
    {
      "code": "c",
      "subcode": 9,
      "name": "사회적 영향"
    },
    {
      "code": "d",
      "subcode": 10,
      "name": "공동선을 위한 AI"
    },
    {
      "code": "d",
      "subcode": 11,
      "name": "인간과 AI의 협업"
    }
  ],
  "m": [
    {
      "code": "a",
      "subcode": 1,
      "name": "AI 기본 개념"
    },
    {
      "code": "a",
      "subcode": 2,
      "name": "데이터와 기계학습"
    },
    {
      "code": "a",
      "subcode": 3,
      "name": "생성형 AI"
    },
    {
      "code": "b",
      "subcode": 4,
      "name": "문제 해결"
    },
    {
      "code": "b",
      "subcode": 5,
      "name": "창작"
    },
    {
      "code": "b",
      "subcode": 6,
      "name": "학습 및 탐구"
    },
    {
      "code": "c",
      "subcode": 7,
      "name": "주체적인 사용"
    },
    {
      "code": "c",
      "subcode": 8,
      "name": "책임감 있는 사용"
    },
    {
      "code": "c",
      "subcode": 9,
      "name": "사회적 영향"
    },
    {
      "code": "d",
      "subcode": 10,
      "name": "공동선을 위한 AI"
    },
    {
      "code": "d",
      "subcode": 11,
      "name": "인간과 AI의 협업"
    }
  ],
  "h": [
    {
      "code": "a",
      "subcode": 1,
      "name": "AI 기본 개념"
    },
    {
      "code": "a",
      "subcode": 2,
      "name": "데이터와 기계학습"
    },
    {
      "code": "a",
      "subcode": 3,
      "name": "생성형 AI"
    },
    {
      "code": "b",
      "subcode": 4,
      "name": "문제 해결"
    },
    {
      "code": "b",
      "subcode": 5,
      "name": "창작"
    },
    {
      "code": "b",
      "subcode": 6,
      "name": "학습 및 탐구"
    },
    {
      "code": "c",
      "subcode": 7,
      "name": "주체적인 사용"
    },
    {
      "code": "c",
      "subcode": 8,
      "name": "책임감 있는 사용"
    },
    {
      "code": "c",
      "subcode": 9,
      "name": "사회적 영향"
    },
    {
      "code": "d",
      "subcode": 10,
      "name": "공동선을 위한 AI"
    },
    {
      "code": "d",
      "subcode": 11,
      "name": "인간과 AI의 협업"
    }
  ]
};

export const QUESTIONS = {
  "e": [
    {
      "q_no": 1,
      "module": 1,
      "sub_no": 1,
      "score": 1,
      "code": "b",
      "subcode": 6,
      "subject": "학습상황에서 AI 활용의 장점"
    },
    {
      "q_no": 2,
      "module": 1,
      "sub_no": 2,
      "score": 1,
      "code": "b",
      "subcode": 6,
      "subject": "AI 결과를 비판적으로 검토하기"
    },
    {
      "q_no": 3,
      "module": 1,
      "sub_no": 3,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "AI의 작동 과정"
    },
    {
      "q_no": 4,
      "module": 1,
      "sub_no": 4,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "데이터의 중요성"
    },
    {
      "q_no": 5,
      "module": 1,
      "sub_no": 5,
      "score": 1,
      "code": "b",
      "subcode": 6,
      "subject": "AI가 추천하는 학습콘텐츠"
    },
    {
      "q_no": 6,
      "module": 1,
      "sub_no": 6,
      "score": 1,
      "code": "c",
      "subcode": 7,
      "subject": "주제적인 AI 활용 태도"
    },
    {
      "q_no": 7,
      "module": 2,
      "sub_no": 1,
      "score": 1,
      "code": "d",
      "subcode": 11,
      "subject": "챗봇 사용시 인간의 역할"
    },
    {
      "q_no": 8,
      "module": 2,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "데이터의 중요성"
    },
    {
      "q_no": 9,
      "module": 2,
      "sub_no": 3,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "행성 분류를 위한 클래스 만들기"
    },
    {
      "q_no": 10,
      "module": 2,
      "sub_no": 4,
      "score": 1,
      "code": "d",
      "subcode": 10,
      "subject": "음성안내 프로토타입 만들기"
    },
    {
      "q_no": 11,
      "module": 2,
      "sub_no": 5,
      "score": 1,
      "code": "c",
      "subcode": 9,
      "subject": "AI의 이로움과 해로움"
    },
    {
      "q_no": 12,
      "module": 2,
      "sub_no": 6,
      "score": 1,
      "code": "c",
      "subcode": 8,
      "subject": "책임감 있게 AI를 활용하는 태도"
    },
    {
      "q_no": 13,
      "module": 3,
      "sub_no": 1,
      "score": 1,
      "code": "d",
      "subcode": 11,
      "subject": "사람이 하는일과 AI가 하는일 구분"
    },
    {
      "q_no": 14,
      "module": 3,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 1,
      "subject": "AI 기술을 적극 탐구하는 자세"
    },
    {
      "q_no": 15,
      "module": 3,
      "sub_no": 3,
      "score": 1,
      "code": "b",
      "subcode": 4,
      "subject": "실생활 문제 해결하기"
    },
    {
      "q_no": 16,
      "module": 3,
      "sub_no": 4,
      "score": 1,
      "code": "b",
      "subcode": 4,
      "subject": "실생활 문제 해결하기"
    },
    {
      "q_no": 17,
      "module": 3,
      "sub_no": 5,
      "score": 1,
      "code": "c",
      "subcode": 7,
      "subject": "주체적인 AI 활용 방법"
    },
    {
      "q_no": 18,
      "module": 4,
      "sub_no": 1,
      "score": 1,
      "code": "a",
      "subcode": 1,
      "subject": "스팸메일 특징과 주의점"
    },
    {
      "q_no": 19,
      "module": 4,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "기계학습 절차"
    },
    {
      "q_no": 20,
      "module": 4,
      "sub_no": 3,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "인공지능 모델 만들기"
    },
    {
      "q_no": 21,
      "module": 4,
      "sub_no": 4,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "인공지능 모델 테스트하기"
    },
    {
      "q_no": 22,
      "module": 4,
      "sub_no": 5,
      "score": 1,
      "code": "d",
      "subcode": 10,
      "subject": "스팸메일 처리 프로토타입 만들기"
    },
    {
      "q_no": 23,
      "module": 4,
      "sub_no": 6,
      "score": 1,
      "code": "c",
      "subcode": 9,
      "subject": "스팸메일 특징과 주의점"
    },
    {
      "q_no": 24,
      "module": 5,
      "sub_no": 1,
      "score": 1,
      "code": "a",
      "subcode": 3,
      "subject": "생성형 AI의 특징"
    },
    {
      "q_no": 25,
      "module": 5,
      "sub_no": 2,
      "score": 1,
      "code": "d",
      "subcode": 10,
      "subject": "인공지능과 지속가능발전"
    },
    {
      "q_no": 26,
      "module": 5,
      "sub_no": 3,
      "score": 1,
      "code": "a",
      "subcode": 3,
      "subject": "AI 활용에 대한 비판적 태도"
    },
    {
      "q_no": 27,
      "module": 5,
      "sub_no": 4,
      "score": 1,
      "code": "b",
      "subcode": 5,
      "subject": "AI 활용 그림 개선"
    },
    {
      "q_no": 28,
      "module": 5,
      "sub_no": 5,
      "score": 1,
      "code": "c",
      "subcode": 8,
      "subject": "기후위기 문구 만들기"
    },
    {
      "q_no": 29,
      "module": 5,
      "sub_no": 6,
      "score": 1,
      "code": "b",
      "subcode": 5,
      "subject": "AI의 다양한 활용 분야"
    }
  ],
  "m": [
    {
      "q_no": 1,
      "module": 1,
      "sub_no": 1,
      "score": 1,
      "code": "b",
      "subcode": 4,
      "subject": "추천시스템 사용 순서"
    },
    {
      "q_no": 2,
      "module": 1,
      "sub_no": 2,
      "score": 1,
      "code": "d",
      "subcode": 11,
      "subject": "AI와 협업하여 진로탐색 계획"
    },
    {
      "q_no": 3,
      "module": 1,
      "sub_no": 3,
      "score": 1,
      "code": "b",
      "subcode": 6,
      "subject": "목적에 맞는 AI 기능 활용"
    },
    {
      "q_no": 4,
      "module": 1,
      "sub_no": 4,
      "score": 1,
      "code": "b",
      "subcode": 6,
      "subject": "AI 활용 과정 평가"
    },
    {
      "q_no": 5,
      "module": 1,
      "sub_no": 5,
      "score": 1,
      "code": "c",
      "subcode": 7,
      "subject": "올바른 AI 활용 습관"
    },
    {
      "q_no": 6,
      "module": 2,
      "sub_no": 1,
      "score": 1,
      "code": "a",
      "subcode": 1,
      "subject": "AI가 하는 일 분류"
    },
    {
      "q_no": 7,
      "module": 2,
      "sub_no": 2,
      "score": 1,
      "code": "c",
      "subcode": 8,
      "subject": "개인정보보호의 중요성"
    },
    {
      "q_no": 8,
      "module": 2,
      "sub_no": 3,
      "score": 1,
      "code": "d",
      "subcode": 11,
      "subject": "인간과 AI의 협업 절차 및 방법"
    },
    {
      "q_no": 9,
      "module": 2,
      "sub_no": 4,
      "score": 1,
      "code": "a",
      "subcode": 3,
      "subject": "생성형 AI와 다른 AI의 차이점 구분하기"
    },
    {
      "q_no": 10,
      "module": 2,
      "sub_no": 5,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "기계학습에서 데이터의 중요성"
    },
    {
      "q_no": 11,
      "module": 3,
      "sub_no": 1,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "탐색을 위한 데이터 수집"
    },
    {
      "q_no": 12,
      "module": 3,
      "sub_no": 2,
      "score": 1,
      "code": "b",
      "subcode": 4,
      "subject": "최단경로탐색"
    },
    {
      "q_no": 13,
      "module": 3,
      "sub_no": 3,
      "score": 1,
      "code": "d",
      "subcode": 10,
      "subject": "자율주행 프로토타입 만들기"
    },
    {
      "q_no": 14,
      "module": 3,
      "sub_no": 4,
      "score": 1,
      "code": "a",
      "subcode": 1,
      "subject": "사례를 중심으로 AI가 하는 일 연결하기"
    },
    {
      "q_no": 15,
      "module": 3,
      "sub_no": 5,
      "score": 1,
      "code": "c",
      "subcode": 9,
      "subject": "AI로 변화하는 일상생활"
    },
    {
      "q_no": 16,
      "module": 4,
      "sub_no": 1,
      "score": 1,
      "code": "b",
      "subcode": 5,
      "subject": "프롬프트 작성하여 이미지 생성하기"
    },
    {
      "q_no": 17,
      "module": 4,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 3,
      "subject": "AI의 결과물의 오류 식별 및 개선하기"
    },
    {
      "q_no": 18,
      "module": 4,
      "sub_no": 3,
      "score": 1,
      "code": "c",
      "subcode": 8,
      "subject": "AI 결과물의 편향성 식별 및 제거하기"
    },
    {
      "q_no": 19,
      "module": 4,
      "sub_no": 4,
      "score": 1,
      "code": "b",
      "subcode": 5,
      "subject": "AI가 생성한 결과물 공유하기"
    },
    {
      "q_no": 20,
      "module": 4,
      "sub_no": 5,
      "score": 1,
      "code": "c",
      "subcode": 7,
      "subject": "생성형 AI 활용 가이드라인 만들기"
    },
    {
      "q_no": 21,
      "module": 5,
      "sub_no": 1,
      "score": 1,
      "code": "b",
      "subcode": 4,
      "subject": "문제해결을 위한 AI 기능 선택"
    },
    {
      "q_no": 22,
      "module": 5,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "기계학습 모델의 정확도 높이기"
    },
    {
      "q_no": 23,
      "module": 5,
      "sub_no": 3,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "데이터 수집 및 분석과정"
    },
    {
      "q_no": 24,
      "module": 5,
      "sub_no": 4,
      "score": 1,
      "code": "d",
      "subcode": 10,
      "subject": "AI학교지킴이 프로토타입 만들기"
    },
    {
      "q_no": 25,
      "module": 5,
      "sub_no": 5,
      "score": 1,
      "code": "c",
      "subcode": 9,
      "subject": "AI로 변화하는 일상생활"
    },
    {
      "q_no": 26,
      "module": 5,
      "sub_no": 6,
      "score": 1,
      "code": "c",
      "subcode": 8,
      "subject": "개인과 타인의 안전 보호하기"
    }
  ],
  "h": [
    {
      "q_no": 1,
      "module": 1,
      "sub_no": 1,
      "score": 1,
      "code": "b",
      "subcode": 4,
      "subject": "필요한 인공지능 프로그램 선택"
    },
    {
      "q_no": 2,
      "module": 1,
      "sub_no": 2,
      "score": 1,
      "code": "b",
      "subcode": 5,
      "subject": "생성형 AI의 결과물 수용, 수정, 거부 판단"
    },
    {
      "q_no": 3,
      "module": 1,
      "sub_no": 3,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "간식의 선호 동아리 선택"
    },
    {
      "q_no": 4,
      "module": 1,
      "sub_no": 4,
      "score": 1,
      "code": "c",
      "subcode": 9,
      "subject": "인공지능 프로그램의 알고리즘 편향 문제 해결"
    },
    {
      "q_no": 5,
      "module": 1,
      "sub_no": 5,
      "score": 1,
      "code": "d",
      "subcode": 11,
      "subject": "관심있는 진로 선택 후 그에 맞는 활용 순서 선택"
    },
    {
      "q_no": 6,
      "module": 1,
      "sub_no": 6,
      "score": 1,
      "code": "c",
      "subcode": 8,
      "subject": "알맞은 윤리 원칙 선택"
    },
    {
      "q_no": 7,
      "module": 2,
      "sub_no": 1,
      "score": 1,
      "code": "b",
      "subcode": 4,
      "subject": "학습 컨디션 예측 모델 프로젝트 계획"
    },
    {
      "q_no": 8,
      "module": 2,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "적절한 기계학습 속성 선택"
    },
    {
      "q_no": 9,
      "module": 2,
      "sub_no": 3,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "의사결정트리 올바른 경로 선택"
    },
    {
      "q_no": 10,
      "module": 2,
      "sub_no": 4,
      "score": 1,
      "code": "c",
      "subcode": 7,
      "subject": "AI 모델의 예측결과에 대한 주체적인 사용 태도 선택"
    },
    {
      "q_no": 11,
      "module": 3,
      "sub_no": 1,
      "score": 1,
      "code": "a",
      "subcode": 1,
      "subject": "지능형 에이전트 처리과정 연결"
    },
    {
      "q_no": 12,
      "module": 3,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "기계학습 핵심 원리 설명 선택"
    },
    {
      "q_no": 13,
      "module": 3,
      "sub_no": 3,
      "score": 1,
      "code": "d",
      "subcode": 10,
      "subject": "기계학습 모델 성능 향상에 필요한 속성 선택"
    },
    {
      "q_no": 14,
      "module": 3,
      "sub_no": 4,
      "score": 1,
      "code": "c",
      "subcode": 8,
      "subject": "개인정보 보호 및 보안 환경 설정"
    },
    {
      "q_no": 15,
      "module": 3,
      "sub_no": 5,
      "score": 1,
      "code": "d",
      "subcode": 10,
      "subject": "개발자들의 제안 채택, 보류, 기각 분류"
    },
    {
      "q_no": 16,
      "module": 4,
      "sub_no": 1,
      "score": 1,
      "code": "a",
      "subcode": 2,
      "subject": "AI 모델을 학습을 위한 데이터와 설명 선택"
    },
    {
      "q_no": 17,
      "module": 4,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 1,
      "subject": "보행자 인식 및 주행 판단 과정 순서도 완성"
    },
    {
      "q_no": 18,
      "module": 4,
      "sub_no": 3,
      "score": 1,
      "code": "b",
      "subcode": 6,
      "subject": "기술을 교과 수업에 적용 사례 선택"
    },
    {
      "q_no": 19,
      "module": 4,
      "sub_no": 4,
      "score": 1,
      "code": "c",
      "subcode": 9,
      "subject": "이해 관계자에 따른 딜레마 연결"
    },
    {
      "q_no": 20,
      "module": 5,
      "sub_no": 1,
      "score": 1,
      "code": "b",
      "subcode": 6,
      "subject": "생성형 AI의 결과물 평가"
    },
    {
      "q_no": 21,
      "module": 5,
      "sub_no": 2,
      "score": 1,
      "code": "a",
      "subcode": 3,
      "subject": "의도하는 결과물을 만들기 위한 프롬프트 조합 설정"
    },
    {
      "q_no": 22,
      "module": 5,
      "sub_no": 3,
      "score": 1,
      "code": "a",
      "subcode": 3,
      "subject": "효과적인 프롬프트 전략 선택"
    },
    {
      "q_no": 23,
      "module": 5,
      "sub_no": 4,
      "score": 1,
      "code": "b",
      "subcode": 5,
      "subject": "개발사에 요청할 기능 알맞게 연결"
    },
    {
      "q_no": 24,
      "module": 5,
      "sub_no": 5,
      "score": 1,
      "code": "c",
      "subcode": 7,
      "subject": "교과 수업에서 생성형 AI 프로그램 주체적인 활용"
    },
    {
      "q_no": 25,
      "module": 5,
      "sub_no": 6,
      "score": 1,
      "code": "d",
      "subcode": 11,
      "subject": "인간과 AI의 협업 시 강점 이해 선택"
    }
  ]
};

export const ACHIEVEMENT_CUTS = {
  "e": {
    "4": 24,
    "3": 18,
    "2": 13,
    "1": 0
  },
  "m": {
    "4": 21,
    "3": 16,
    "2": 12,
    "1": 0
  },
  "h": {
    "4": 21,
    "3": 17,
    "2": 13,
    "1": 0
  }
};

export const SCALE_SCORES = {
  "e": [
    {
      "raw": 0,
      "scale": 127,
      "level": 1
    },
    {
      "raw": 1,
      "scale": 132,
      "level": 1
    },
    {
      "raw": 2,
      "scale": 136,
      "level": 1
    },
    {
      "raw": 3,
      "scale": 140,
      "level": 1
    },
    {
      "raw": 4,
      "scale": 144,
      "level": 1
    },
    {
      "raw": 5,
      "scale": 147,
      "level": 1
    },
    {
      "raw": 6,
      "scale": 151,
      "level": 1
    },
    {
      "raw": 7,
      "scale": 154,
      "level": 1
    },
    {
      "raw": 8,
      "scale": 157,
      "level": 1
    },
    {
      "raw": 9,
      "scale": 160,
      "level": 2
    },
    {
      "raw": 10,
      "scale": 163,
      "level": 2
    },
    {
      "raw": 11,
      "scale": 165,
      "level": 2
    },
    {
      "raw": 12,
      "scale": 168,
      "level": 2
    },
    {
      "raw": 13,
      "scale": 171,
      "level": 2
    },
    {
      "raw": 14,
      "scale": 174,
      "level": 3
    },
    {
      "raw": 15,
      "scale": 177,
      "level": 3
    },
    {
      "raw": 16,
      "scale": 180,
      "level": 3
    },
    {
      "raw": 17,
      "scale": 183,
      "level": 3
    },
    {
      "raw": 18,
      "scale": 186,
      "level": 3
    },
    {
      "raw": 19,
      "scale": 189,
      "level": 3
    },
    {
      "raw": 20,
      "scale": 193,
      "level": 3
    },
    {
      "raw": 21,
      "scale": 196,
      "level": 3
    },
    {
      "raw": 22,
      "scale": 200,
      "level": 3
    },
    {
      "raw": 23,
      "scale": 204,
      "level": 4
    },
    {
      "raw": 24,
      "scale": 209,
      "level": 4
    },
    {
      "raw": 25,
      "scale": 214,
      "level": 4
    },
    {
      "raw": 26,
      "scale": 219,
      "level": 4
    },
    {
      "raw": 27,
      "scale": 225,
      "level": 4
    },
    {
      "raw": 28,
      "scale": 231,
      "level": 4
    },
    {
      "raw": 29,
      "scale": 237,
      "level": 4
    }
  ],
  "m": [
    {
      "raw": 0,
      "scale": 130,
      "level": 1
    },
    {
      "raw": 1,
      "scale": 135,
      "level": 1
    },
    {
      "raw": 2,
      "scale": 140,
      "level": 1
    },
    {
      "raw": 3,
      "scale": 145,
      "level": 1
    },
    {
      "raw": 4,
      "scale": 149,
      "level": 1
    },
    {
      "raw": 5,
      "scale": 152,
      "level": 1
    },
    {
      "raw": 6,
      "scale": 156,
      "level": 1
    },
    {
      "raw": 7,
      "scale": 159,
      "level": 1
    },
    {
      "raw": 8,
      "scale": 162,
      "level": 2
    },
    {
      "raw": 9,
      "scale": 165,
      "level": 2
    },
    {
      "raw": 10,
      "scale": 168,
      "level": 2
    },
    {
      "raw": 11,
      "scale": 171,
      "level": 2
    },
    {
      "raw": 12,
      "scale": 174,
      "level": 3
    },
    {
      "raw": 13,
      "scale": 177,
      "level": 3
    },
    {
      "raw": 14,
      "scale": 180,
      "level": 3
    },
    {
      "raw": 15,
      "scale": 183,
      "level": 3
    },
    {
      "raw": 16,
      "scale": 186,
      "level": 3
    },
    {
      "raw": 17,
      "scale": 190,
      "level": 3
    },
    {
      "raw": 18,
      "scale": 194,
      "level": 3
    },
    {
      "raw": 19,
      "scale": 198,
      "level": 4
    },
    {
      "raw": 20,
      "scale": 203,
      "level": 4
    },
    {
      "raw": 21,
      "scale": 208,
      "level": 4
    },
    {
      "raw": 22,
      "scale": 213,
      "level": 4
    },
    {
      "raw": 23,
      "scale": 220,
      "level": 4
    },
    {
      "raw": 24,
      "scale": 226,
      "level": 4
    },
    {
      "raw": 25,
      "scale": 233,
      "level": 4
    },
    {
      "raw": 26,
      "scale": 239,
      "level": 4
    }
  ],
  "h": [
    {
      "raw": 0,
      "scale": 126,
      "level": 1
    },
    {
      "raw": 1,
      "scale": 134,
      "level": 1
    },
    {
      "raw": 2,
      "scale": 140,
      "level": 1
    },
    {
      "raw": 3,
      "scale": 146,
      "level": 1
    },
    {
      "raw": 4,
      "scale": 151,
      "level": 1
    },
    {
      "raw": 5,
      "scale": 156,
      "level": 1
    },
    {
      "raw": 6,
      "scale": 160,
      "level": 1
    },
    {
      "raw": 7,
      "scale": 164,
      "level": 1
    },
    {
      "raw": 8,
      "scale": 168,
      "level": 2
    },
    {
      "raw": 9,
      "scale": 172,
      "level": 2
    },
    {
      "raw": 10,
      "scale": 176,
      "level": 2
    },
    {
      "raw": 11,
      "scale": 179,
      "level": 2
    },
    {
      "raw": 12,
      "scale": 183,
      "level": 2
    },
    {
      "raw": 13,
      "scale": 187,
      "level": 3
    },
    {
      "raw": 14,
      "scale": 191,
      "level": 3
    },
    {
      "raw": 15,
      "scale": 195,
      "level": 3
    },
    {
      "raw": 16,
      "scale": 199,
      "level": 3
    },
    {
      "raw": 17,
      "scale": 203,
      "level": 3
    },
    {
      "raw": 18,
      "scale": 207,
      "level": 3
    },
    {
      "raw": 19,
      "scale": 212,
      "level": 4
    },
    {
      "raw": 20,
      "scale": 217,
      "level": 4
    },
    {
      "raw": 21,
      "scale": 223,
      "level": 4
    },
    {
      "raw": 22,
      "scale": 229,
      "level": 4
    },
    {
      "raw": 23,
      "scale": 235,
      "level": 4
    },
    {
      "raw": 24,
      "scale": 243,
      "level": 4
    },
    {
      "raw": 25,
      "scale": 251,
      "level": 4
    }
  ]
};

export const SCALE_LEVEL_MAX = {
  "e": {
    "1": 157,
    "2": 172,
    "3": 202,
    "4": 237
  },
  "m": {
    "1": 159,
    "2": 172,
    "3": 197,
    "4": 239
  },
  "h": {
    "1": 164,
    "2": 183,
    "3": 211,
    "4": 251
  }
};

export const ACHIEVEMENT_LEVEL_DESC = {
  "4": "‘일상생활과 교과학습에 기반이 되는 기초소양으로서 AI·디지털 기술에 대한 기본 지식과 이해를 바탕으로 윤리적이고 비판적으로 AI·디지털 기술을 활용하고, 창의적이고 주체적으로 AI와 협업하여 자신과 사회의 문제를 해결할 수 있는 역량’을 충분히 갖춘 수준",
  "3": "‘일상생활과 교과학습에 기반이 되는 기초소양으로서 AI·디지털 기술에 대한 기본 지식과 이해를 바탕으로 윤리적이고 비판적으로 AI·디지털 기술을 활용하고, 창의적이고 주체적으로 AI와 협업하여 자신과 사회의 문제를 해결할 수 있는 역량’을 적절히 갖춘 수준",
  "2": "‘일상생활과 교과학습에 기반이 되는 기초소양으로서 AI·디지털 기술에 대한 기본 지식과 이해를 바탕으로 윤리적이고 비판적으로 AI·디지털 기술을 활용하고, 창의적이고 주체적으로 AI와 협업하여 자신과 사회의 문제를 해결할 수 있는 역량’을 최소한으로 갖춘 수준",
  "1": "‘일상생활과 교과학습에 기반이 되는 기초소양으로서 AI·디지털 기술에 대한 기본 지식과 이해를 바탕으로 윤리적이고 비판적으로 AI·디지털 기술을 활용하고, 창의적이고 주체적으로 AI와 협업하여 자신과 사회의 문제를 해결할 수 있는 역량’이 부족한 수준"
};

export const AREA_LEVEL_COMMENTS = {
  "e": {
    "a": {
      "lev_high": "학생은 인공지능의 다양한 원리를 사례를 들어 설명할 수 있습니다. 데이터 기반 인공지능이 만들어지는 전체 과정을 탐색하고, 나아가 일상에서 필요한 데이터를 직접 수집하고 분석하는 통합적인 역량을 보여줍니다. 또한, 생성형 인공지능이 만든 결과물을 맹목적으로 수용하지 않고, 그것이 편향되거나 틀릴 수 있다는 사실을 인지하며 비판적으로 평가하는 성숙한 태도를 갖춘 수준입니다.",
      "lev_mid": "학생은 인공지능의 기본 원리와 기계학습 같은 핵심 개념을 자신의 언어로 설명할 수 있습니다. 개념 이해에 그치지 않고, 기계학습 과정을 직접 체험하거나 생성형 인공지능을 활용해 결과물을 만들어보는 등 기술을 적극적으로 탐색하고 경험하려 합니다. 인공지능 기술이 무엇을 할 수 있는지 구체적으로 이해하고 활용법을 익히는 데 중점을 두는 수준입니다.",
      "lev_low": "학생은 인공지능 기술에 대한 흥미와 호기심을 보이며 탐구를 시작하는 단계입니다. 주변에서 어떤 것이 인공지능 기술이고 아닌지를 구분할 수 있으며, 다양한 인공지능 사례를 찾아보며 기본적인 개념을 형성해 나갑니다. 기술의 원리보다는, 인공지능이 우리 생활과 어떻게 관련되어 있는지 관심을 갖고 탐색하려는 태도를 보이는 수준입니다."
    },
    "b": {
      "lev_high": "학생은 AI·디지털 도구를 단순히 사용하는 것을 넘어, 학습 및 창작과 같은 구체적인 목적에 맞게 활용하고 그 과정과 결과를 비판적으로 평가할 수 있습니다. 학습 과정에서 중요한 결정을 내릴 때 인공지능이 제시한 정보를 그대로 수용하지 않고 검토하는 자세를 보입니다. 또한, 창작 활동에 AI·디지털 도구를 활용할 때 나타나는 장점과 단점을 명확히 비교하여 설명할 수 있는 등 기술의 명암을 균형 있게 이해하는 수준입니다.",
      "lev_mid": "학생은 AI·디지털 도구를 활용하여 실생활 및 학습에서 마주하는 간단한 문제를 해결하고 구체적인 결과물을 만들어내는 경험을 할 수 있습니다. 문제 해결 과정을 스스로 탐색하고 실행할 수 있으며, 문자, 그림, 영상 등을 AI·디지털 도구로 직접 제작하는 체험을 즐깁니다. 다양한 도구를 사용해 보며 새로운 아이디어를 시도하는 등 기술에 대한 적극적인 태도를 보이는 수준입니다.",
      "lev_low": "학생은 AI·디지털 도구가 우리 주변에서 어떻게 쓰이는지 발견하고 탐색하며 기본적인 호기심을 갖는 단계입니다. 일상생활이나 학습 상황에서 인공지능 기술이 문제 해결에 사용된 사례를 찾아볼 수 있고, 인공지능이 그림이나 음악 등 창작 활동에 활용된 사례를 찾아 설명할 수 있습니다."
    },
    "c": {
      "lev_high": "학생은 AI·디지털 윤리 원칙을 내면화하여 책임감 있는 태도로 기술을 사용합니다. 개인정보 데이터를 안전하게 관리하고 보호하려는 태도를 꾸준히 보이며, 타인의 창작물을 존중하며 인공지능을 책임감 있게 사용하려는 자세를 갖추고 있습니다. 여기서 더 나아가 AI·디지털 기술이 사회에 주는 이로움과 해로움을 스스로 파악하려는 비판적 자세를 지닙니다.",
      "lev_mid": "학생은 윤리적 개념 이해를 넘어 안전하고 책임감 있는 사용법을 직접 탐색하고 실천할 수 있습니다. 인공지능 과의존, 저작권 침해, 딥페이크와 같은 구체적인 윤리 문제에 대응하여 안전한 사용법을 탐색하고 실천합니다. 또한, 타인의 안전과 저작권 보호 등 책임감 있는 사용법을 적극적으로 탐색할 수 있으며, 인공지능이 사회에 미치는 영향을 스스로 조사할 수 있습니다.",
      "lev_low": "학생은 AI·디지털 윤리의 기본적인 규칙을 이해하고 설명할 수 있습니다. 인공지능을 안전하게 사용하기 위한 기본 규칙과 개인정보 보호의 중요성을 설명할 수 있고, 저작권 및 타인의 안전을 보호하는 등 책임감 있는 사용법이 무엇인지 말할 수 있습니다. 인공지능이 우리에게 어떤 도움을 주는지, 미래에는 어떻게 발전할지에 대해 관심을 갖는 수준입니다."
    },
    "d": {
      "lev_high": "학생은 인공지능을 더 나은 사회를 만드는 협업의 대상으로 인식하고, 문제 해결 과정에 주체적으로 참여하려는 태도를 갖습니다. 지속 가능한 사회 발전을 위해 인공지능 시스템으로 문제를 해결하는 과정에 적극적으로 참여하는 태도를 보입니다. 또한, 인공지능을 새로운 협업 파트너로 여기며 올바르게 협업하는 자세를 갖추고 있습니다.",
      "lev_mid": "학생은 인공지능의 역할을 파악하고 분석하여 새로운 아이디어를 만들고 표현할 수 있습니다. 지속 가능한 사회 발전을 위해 인공지능이 어떻게 활용되는지 파악하고, 이를 바탕으로 다양한 아이디어를 내어 간단한 모형으로 표현할 수 있습니다. 나아가 인간과 인공지능이 주변을 인식하고 학습하는 방식을 비교하고 분석할 수 있으며, 일상생활 속에서 AI로 해결할 수 있는 문제를 스스로 정의할 수 있습니다.",
      "lev_low": "학생은 우리 생활 속에서 인공지능의 쓰임새와 역할을 발견하고 탐색할 수 있습니다. 우리 주변에서 인공지능이 잘하는 일을 발견할 수 있고, 지속 가능한 사회의 발전을 위해 인공지능이 활용된 사례를 찾아볼 수 있습니다."
    }
  },
  "m": {
    "a": {
      "lev_high": "학생은 AI의 개념과 주요 원리를 이해하고, 사례를 바탕으로 AI가 하는 일(예측·분석·추천·생성)을 구별하여 설명할 수 있습니다. 기계학습 유형과 데이터 수집 및 분석 과정을 설명하고, 다양한 데이터 유형을 비교하여 시각화하거나 간단한 기계학습 모델을 만들 수 있습니다. 또한 생성형 AI와 다른 AI의 차이를 설명하고, 생성형 AI로 만든 결과물의 오류나 편향 가능성을 책임감 있게 검토합니다.",
      "lev_mid": "학생은 AI의 주요 특징과 원리를 이해하고, 사례를 바탕으로 AI가 하는 일(예측·분석·추천·생성)을 구별할 수 있습니다. 기계학습의 주요 개념과 유형, 과정을 단계적으로 설명할 수 있으며, 기계학습에 활용되는 데이터의 중요성을 인식합니다. 또한 생성형 AI와 다른 AI를 구별하고, 생성형 AI를 활용해 텍스트나 이미지 결과물을 만들며 주요 특징을 설명할 수 있습니다.",
      "lev_low": "학생은 AI가 무엇인지 알고, 생활 속 사례를 통해 AI가 예측·분석·추천·생성 등의 일을 할 수 있음을 이해합니다. 데이터가 AI 학습에 활용된다는 점을 이해하고, 생성형 AI를 활용하여 간단한 결과물을 만들 수 있습니다. AI·디지털 기술에 관심과 호기심을 가지고 탐구하려는 태도를 보입니다."
    },
    "b": {
      "lev_high": "학생은 일상생활과 학습 상황에서 문제를 해결하기 위해 적절한 AI·디지털 도구를 선택하고 목적에 맞게 활용할 수 있습니다. AI·디지털 도구를 활용하여 글, 이미지, 소리, 동영상 등의 결과물을 창의적으로 제작하고, 결과물의 신뢰성과 적절성을 비판적으로 검토 및 개선할 수 있습니다. 또한 활용 과정을 성찰하고, 스스로 사고하고 판단하는 과정을 유지하며 자기주도적으로 학습·창작·문제해결을 수행할 수 있습니다.",
      "lev_mid": "학생은 AI·디지털 도구를 활용한 문제해결, 창작, 학습 사례를 통해 도구의 활용 방식과 절차를 설명할 수 있습니다. AI·디지털 도구를 활용하여 실생활 문제와 학습 문제를 해결하고, 다양한 형태의 결과물을 만들 수 있습니다. 또한 AI가 생성한 콘텐츠임을 표시하는 등 책임감 있는 태도를 보이며, AI·디지털 도구 활용이 실제로 어떻게 도움이 되었는지 설명할 수 있습니다.",
      "lev_low": "학생은 AI·디지털 도구가 실생활 문제해결, 창작, 학습에 활용될 수 있음을 이해합니다. AI·디지털 도구를 활용하여 간단한 문제를 해결하거나 결과물을 만들 수 있으며, AI의 결과를 확인하고 검토해야 할 필요성을 인식합니다. 또한 일상생활과 다양한 분야의 AI 융합 사례에 관심을 가지고 탐구하려는 태도를 보입니다."
    },
    "c": {
      "lev_high": "학생은 AI와 관련된 인간의 주체성과 권리 보호 사례를 탐색하고, AI를 주체적으로 사용하기 위한 자신만의 가이드라인을 만들어 실천할 수 있습니다. AI·디지털 기술이 자신과 타인, 사회에 미치는 영향을 고려하여 책임감 있게 활용합니다. 또한 AI 결과를 윤리적 관점에서 비판적으로 검토하고, 윤리적 문제를 예방하고 해결하기 위한 방안을 적극적으로 탐구합니다. 나아가 AI와 관련된 직업에 관심을 갖고 자신의 진로를 탐색합니다.",
      "lev_mid": "학생은 사례를 통해 AI를 주체적이고 책임감 있게 활용하는 방법을 이해하고, AI 윤리 원칙을 설명할 수 있습니다. AI 사용 과정에서 발생할 수 있는 개인정보 침해, 사생활 노출, 편향 등의 위험을 이해하고, 개인과 타인의 안전을 보호하려는 태도를 보입니다. 또한 AI가 일상생활과 사회에 미치는 긍정적·부정적 영향을 이해하며, AI와 관련된 윤리적 딜레마 상황에서 문제의 원인과 해결 방안을 다양한 관점에서 논의할 수 있습니다.",
      "lev_low": "학생은 AI·디지털 기술을 사용할 때 개인정보 보호와 타인의 안전을 고려해야 함을 알고, 주체적이고 안전한 사용 방법을 탐구하려는 태도를 보입니다. AI 활용 사례의 긍정적·부정적 영향을 구분할 수 있으며, 공정성, 신뢰성과 같은 AI의 윤리 원칙의 중요성을 이해합니다. 또한 AI가 미래의 생활과 직업에 미치는 변화에 관심을 보입니다."
    },
    "d": {
      "lev_high": "학생은 지속 가능한 사회 발전을 위해 AI의 설계 목적과 활용 사례를 탐구하고, 인간을 이롭게 하기 위해 AI로 해결할 수 있는 문제를 정의할 수 있습니다. AI를 활용한 문제해결 방법을 구상하고, 이를 글, 그림, 도식, 코드 등을 활용한 프로토타입으로 만들수 있으며, AI가 인간의 가치·목적·맥락에 부합하는지 비판적으로 검토합니다. 또한 AI와 협업하는 과정에서 인간의 역할을 이해하고, 의사결정의 주도권을 유지하며 AI와 효과적으로 협업하려는 태도를 보입니다.",
      "lev_mid": "학생은 지속 가능한 사회 발전을 위해 AI가 활용되는 사례를 탐색하고, AI로 해결할 수 있는 문제를 정의할 수 있습니다. AI를 활용한 문제해결 방법을 제안하고, 이를 글, 그림, 도식, 코드 등을 활용하여 간단한 프로토타입으로 만들 수 있습니다. 또한 일상생활을 비롯한 다양한 분야에서 AI와 협업하여 문제를 해결하는 방식을 설명할 수 있습니다. AI를 협업의 대상으로 인식하고 다양한 협업 전략을 시도하며, 이 과정에서 최종 의사결정의 책임이 인간에게 있음을 이해합니다.",
      "lev_low": "학생은 사례를 통해 AI가 지속 가능한 사회 발전을 위해 활용될 수 있음을 이해하고, 인간을 이롭게 하기 위해 AI로 해결할 수 있는 문제를 발견할 수 있습니다. 또한 AI와 인간이 함께 문제를 해결한 사례를 통해 인간과 AI의 역할을 구분하고, 인간이 주도적으로 판단해야 함을 이해합니다. AI를 새로운 협업 대상으로 인식하며, 효과적인 협업 전략을 탐색하려는 태도를 보입니다."
    }
  },
  "h": {
    "a": {
      "lev_high": "학생은 지능형 에이전트의 개념을 이해하고 AI 의사결정 원리를 비교·분석하며, 목적에 부합한 데이터 전처리와 모델 선택·훈련 역량을 갖추고 있습니다. 데이터와 AI 산출물을 비판적·다각적으로 해석하는 성찰적 태도와 함께, 생성형 AI의 효과적인 프롬프트 전략을 구상하고 결과물을 합리적으로 평가하는 역량을 갖추었습니다.",
      "lev_mid": "학생은 지능형 에이전트 개념과 AI 의사결정 원리를 사례를 통해 설명하고, 기계학습 데이터 속성·전처리 및 모델 유형 차이를 구분할 수 있습니다. 목적에 맞는 모델 훈련 과정을 적극적으로 탐색하며, 프롬프트 구성에 따른 생성형 AI 결과 차이를 이해하고 효과적인 전략을 익히려 노력합니다.",
      "lev_low": "학생은 AI의 기본 개념과 주요 기능에 호기심을 가지고 관련 사례를 탐색하는 단계입니다. 기계학습의 기본 개념과 데이터 전처리 과정을 파악하는 데 노력하며, 프롬프트 구성에 따라 생성형 AI의 결과가 달라질 수 있음을 이해하고 효과적인 프롬프트 전략의 특징을 설명할 수 있습니다."
    },
    "b": {
      "lev_high": "학생은 다양한 AI 융합 사례 분석을 통해 문제해결 과정을 주도적으로 계획·수행하며 결과를 비판적으로 성찰할 수 있습니다. 창의적 아이디어로 AI 결과물을 제작·개선하고 목적에 맞는 도구를 선택하여 정보를 수집합니다. AI 산출물을 깊이 있게 검토하며, 자신의 학습 과정을 스스로 계획·점검·조정하는 탁월한 자기주도적 태도를 보입니다.",
      "lev_mid": "학생은 AI 융합 사례를 통해 문제해결 과정을 설명하고, AI·디지털 도구를 활용한 문제 해결과 창작 결과물 개선 방법을 파악합니다. AI가 생성한 결과물을 수용·거절하며 비판적으로 평가하려 노력하고, 학습 상황에 따라 적절한 도구를 선택하여 자기주도적으로 활용하는 태도를 보입니다.",
      "lev_low": "학생은 일상 속 AI 융합 사례에 관심을 가지고 안내에 따라 디지털 도구를 활용한 기본적인 문제해결 및 창작 활동에 참여합니다. AI 결과물의 신뢰성을 판단하려 노력하며, 학습 목적에 맞는 도구를 선택하여 학습 및 과제 수행에 활용하는 기초적인 역량을 갖추고 있습니다."
    },
    "c": {
      "lev_high": "학생은 상황과 목적에 따라 AI·디지털 도구를 주도적으로 활용하고 결과를 비판적으로 검토·재구성하며, AI 윤리 원칙과 잠재적 한계를 설명하고 결과물의 신뢰성을 비판적으로 판단합니다. AI 기술의 사회적 영향을 중장기 관점에서 탐색하고, 윤리적 딜레마 사례에서 다양한 관점을 고려하며 책임 있는 자세로 윤리적 문제 해결에 적극 참여합니다.",
      "lev_mid": "학생은 상황과 목적에 맞는 AI·디지털 도구 활용 기준을 설명하고 결과를 비판적으로 해석하려 노력하며, AI 윤리 원칙과 한계를 이해하고 결과물의 신뢰성·윤리적 적절성을 판단할 수 있습니다. AI 기술로 인한 사회 변화를 탐색하고, 개인과 사회에 미치는 영향을 살펴보는 태도를 보입니다.",
      "lev_low": "학생은 AI 도구와 결과물을 안전하게 사용하는 방법에 관심을 갖고 탐구를 시작하는 단계입니다. 개인정보 보호와 AI 윤리 원칙의 필요성을 인지하고 있으며, AI의 발전이 사회와 인간에게 미치는 영향과 관련 윤리적 쟁점에 관심을 갖고 있습니다."
    },
    "d": {
      "lev_high": "학생은 지속 가능한 발전을 위해 다양한 관점으로 문제를 정의하고 인간 중심 가치가 반영된 AI·디지털 프로젝트를 계획하고 수행할 수 있습니다. AI와 효과적으로 협업하는 절차와 방법에 따라 인간의 감독과 통제가 필요한 상황을 판단하며 안전·도덕성·존엄성을 보호하는 태도를 갖추고 있습니다.",
      "lev_mid": "학생은 지속 가능한 사회를 위한 AI·디지털 프로젝트를 탐색하고 인간 중심 가치의 필요성을 이해하며, AI와 협업하는 과정에서 인간 역량 증강 사례와 감독·통제의 중요성을 설명할 수 있습니다. AI 협업 절차와 방법을 탐색하고 진로와 연계하여 생각하는 태도를 보입니다.",
      "lev_low": "학생은 AI·디지털 기술이 지속 가능한 사회에 활용되는 사례에 관심을 갖고, 인간과 AI가 협업하는 과정에 호기심을 갖는 단계입니다. AI 설계 시 인간 중심 가치가 필요함을 인지하며 AI 결과물을 인간의 가치와 목적에 맞게 검토·조정하려는 기초적인 태도를 갖추고 있습니다."
    }
  }
};

export const IMPROVEMENT_MATERIALS = {
  "e": [
    {
      "order": 1,
      "code": "a",
      "q_no": 14,
      "module": 3,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "유튜브 추천 영상이나 카메라 필터처럼 인공지능은 이미 우리 일상 속에 있어요. 인공지능을 단순히 즐기지만 말고, '이것은 어떤 원리로 작동하는 걸까?' 하고 질문을 던져보세요. 주변의 기능들을 찾아보며 작동 원리를 궁금해하는 것부터 탐구의 시작입니다.",
      "study": "유튜브 추천 알고리즘, 번역기 등 일상과 산업 전반에 스며든 AI의 활약을 살펴봅니다. 주변의 인공지능 사례를 직접 발견하며, 기술과 공존할 미래를 탐색하고 AI의 놀라운 능력을 확인하는 학습 활동입니다.",
      "url": "http://s.senaidl.kr/F1Fbo",
      "qr": "2026-e-3-2.png"
    },
    {
      "order": 2,
      "code": "c",
      "q_no": 28,
      "module": 5,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "인공지능은 우리가 어떻게 쓰느냐에 따라 착한 도구도, 나쁜 도구도 될 수 있어요. 다른 사람의 사진을 마음대로 바꾸거나 가짜 뉴스를 인공지능으로 만들어 친구들을 속이는 행동은 큰 피해를 줄 수 있습니다. 인공지능을 사용할 때에는 인공지능이 미치는 영향을 생각하고 스스로 행동에 책임을 지는 디지털 시민이 되도록 노력해요.",
      "study": "생성형 AI가 만든 작품의 윤리적 문제와 저작권에 대해 학습합니다. 생성형AI로 만든 작품에 AI 디지털 윤리적 문제는 없는지 체크리스트를 통해 스스로 점검하고 올바른 출처를 적어보는 교육 자료입니다.",
      "url": "http://s.senaidl.kr/V8erc",
      "qr": "2026-e-5-5.png"
    },
    {
      "order": 3,
      "code": "a",
      "q_no": 18,
      "module": 4,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "인공지능은 빠르게 계산하고 많은 데이터를 분석하는 일을 잘해요. 예를 들어 번역을 하거나 사진을 보고 물건을 알아맞히고 스팸메일을 구분하거나 길을 추천하는 것도 잘해요. 사람에게는 시간이 오래 걸리는 반복 작업을 대신해 주기도 해요. 이런 특징을 알면 적절한 곳에 인공지능을 활용할 수 있어요.",
      "study": "AI과 일반 기계의 차이점을 명확히 비교하고 퀴즈를 통해 인공지능 여부를 직접 구분합니다. 스스로 판단하는 AI의 핵심 원리를 이해한 뒤 아이디어를 더해 일상 속 사물을 똑똑한 AI 기기로 변신시켜 보는 창의적 탐구 활동입니다. 개념 습득과 상상력을 바탕으로 AI와 소통하는 미래 역량을 기릅니다.",
      "url": "http://s.senaidl.kr/TU2rI",
      "qr": "2026-e-4-1.png"
    },
    {
      "order": 4,
      "code": "a",
      "q_no": 26,
      "module": 5,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "생성형 인공지능은 문장을 확률과 통계 바탕으로 만들어내기 때문에 사실이 아닌 것을 진짜처럼 말할 때가 있어요. 인공지능은 존재하지 않는 사건이나 잘못된 정보를 마치 정답인 것처럼 답하기도 합니다. 인공지능이 만든 글이나 그림을 볼 때에는 인공지능의 결과를 무조건 믿지 않고 비판적으로 분석하는 태도가 중요해요.",
      "study": "인공지능이 제공하는 정보 중에는 사실과 다른 내용이 섞여 있을 수 있음을 이해합니다. 퀴즈와 사례를 통해 AI 답변을 무조건 믿기보다 비판적으로 검토하는 태도를 기르며, 최종 책임은 사용자에게 있음을 배우고 실천합니다.",
      "url": "http://s.senaidl.kr/cN4WH",
      "qr": "2026-e-5-3.png"
    },
    {
      "order": 5,
      "code": "b",
      "q_no": 1,
      "module": 1,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "우리는 학습을 위해 인공지능에게 문제를 만들게 하거나, 다양한 자료를 정리하도록 도움을 받을 수 있어요. 하지만 인공지능도 때때로 사실과 다른 내용을 말하거나 표현이 애매할 수 있어요. 그래서 교과서나 책의 내용과 비교해 확인하고, 틀린 부분은 수정하거나 빼면서 활용하는 태도가 가장 중요해요.",
      "study": "디지털 마법학교 입학 시험 스토리 속에서 방탈출 형태의 3가지 미션을 해결하며 AI·디지털 도구를 학습에 직접 활용하고, 도구별 장단점 평가표 작성을 통해 각 도구의 특성과 한계를 이해할 수 있습니다.",
      "url": "http://s.senaidl.kr/TN0YX",
      "qr": "2026-e-1-1.png"
    },
    {
      "order": 6,
      "code": "c",
      "q_no": 12,
      "module": 2,
      "module_no": 6,
      "allCorrect": false,
      "feedback": "인공지능은 우리가 어떻게 쓰느냐에 따라 착한 도구도, 나쁜 도구도 될 수 있어요. 다른 사람의 사진을 마음대로 바꾸거나 가짜 뉴스를 인공지능으로 만들어 친구들을 속이는 행동은 큰 피해를 줄 수 있습니다. 인공지능을 사용할 때에는 인공지능이 미치는 영향을 생각하고 스스로 행동에 책임을 지는 디지털 시민이 되도록 노력해요.",
      "study": "생성형 AI가 만든 작품의 윤리적 문제와 저작권에 대해 학습합니다. 생성형AI로 만든 작품에 AI 디지털 윤리적 문제는 없는지 체크리스트를 통해 스스로 점검하고 올바른 출처를 적어보는 교육 자료입니다.",
      "url": "http://s.senaidl.kr/V8erc",
      "qr": "2026-e-2-6.png"
    },
    {
      "order": 7,
      "code": "c",
      "q_no": 6,
      "module": 1,
      "module_no": 6,
      "allCorrect": false,
      "feedback": "어려운 과제나 문제가 주어졌을 때 곧바로 인공지능에게 정답을 묻는 습관은 도움이 되지 않습니다. 따라서 내가 먼저 고민하고, 자료를 찾아본 후에 부족한 부분을 보완하는 용도로 인공지능을 활용해야 해요. 인공지능에 의존하기보다는 나의 지적 호기심과 생각하는 힘을 먼저 기르는 주도적인 탐구 태도를 가지시기 바랍니다.",
      "study": "디지털 세상, 나도 예의 있게 활동지는 초등학생이 온라인 예절과 책임 있는 행동을 실제 사례로 구분하고, 자기 점검과 선서문 활동을 통해 배려와 안전한 디지털 시민 태도를 기르도록 돕는 교육자료입니다.",
      "url": "http://s.senaidl.kr/S1zp7",
      "qr": "2026-e-1-6.png"
    },
    {
      "order": 8,
      "code": "b",
      "q_no": 15,
      "module": 3,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능과 디지털 도구는 우리 주변의 불편한 문제를 해결할 때 유용하게 쓰여요. 문제를 풀거나 탐구할 때는 '내가 겪는 일상 속 불편함을 어떤 디지털 도구로 해결할 수 있을까?'를 먼저 생각하고, 그 해결 순서를 차근차근 계획해보세요. 기술을 사용해 문제를 해결하는 구체적인 과정을 떠올려보는 것이 중요합니다.",
      "study": "사례를 다양한 디지털 플랫폼을 활용하여 문제를 해결하는 방법과 그 과정을 검증하는 방법을 학습합니다. 우리가 겪는 다양한 사례를 디지털 기기를 사용하여 해결할 수 있음을 경험적으로 알 수 있도록 구성하였습니다.",
      "url": "http://s.senaidl.kr/3y7Nr",
      "qr": "2026-e-3-3.png"
    },
    {
      "order": 9,
      "code": "c",
      "q_no": 23,
      "module": 4,
      "module_no": 6,
      "allCorrect": false,
      "feedback": "코딩은 내가 가진 생각을 컴퓨터가 이해할 수 있는 언어로 번역하는 과정입니다. 이를 위해 나의 아이디어가 어떤 순서로 움직여야 하는지 먼저 쪼개어 정리해보는 단계가 필요해요. 인공지능 도구나 블록 코딩의 기능을 활용할 때 각 명령어가 나의 아이디어를 정밀하게 구현하고 있는지 논리적인 흐름을 점검해 보세요.",
      "study": "인공지능의 두 얼굴'은 인공지능 기술로 변화된 생활 모습을 학습하는 활동입니다. 인공지능의 좋은 영향, 나쁜 영향을 담은 만화를 보고, 제시된 단어를 활용해 정리합니다. 이를 통해 인공지능의 양면성에 대해 알아볼 수 있습니다.",
      "url": "http://s.senaidl.kr/PHILp",
      "qr": "2026-e-4-6.png"
    },
    {
      "order": 10,
      "code": "b",
      "q_no": 5,
      "module": 1,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "학습 문제 해결 사례라고 해서 거창하고 복잡한 기술이 필요한 것은 아닙니다. 모둠 과제를 할 때 친구들과 온라인 문서로 의견을 모았던 경험, 사회 시간에 가기 힘든 유적지를 가상현실(VR) 지도로 탐방했던 경험과 같이 우리 주변의 디지털 도구들이 우리의 학습을 편리하고 풍부하게 만둘어준 자신만의 사례를 찾아보세요.",
      "study": "탐정 콘셉트의 OX 퀴즈와 탐정 일지 작성을 통해 일상 속 다양한 학습 상황(정보 검색, 감상문 쓰기, 관찰 일지 등)에서 AI·디지털 도구를 언제 활용하면 좋은지 스스로 판단하고, 상황에 알맞은 도구 선택 능력을 익힐 수 있습니다.",
      "url": "http://s.senaidl.kr/aaFXH",
      "qr": "2026-e-1-5.png"
    },
    {
      "order": 11,
      "code": "a",
      "q_no": 21,
      "module": 4,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능은 많은 데이터를 보고 규칙을 배우는 방식으로 작동해요. 예를 들어, 스팸 메일을 걸러내거나 추천 영상을 보여주는 것도 인공지능의 원리를 이용한 거예요. 다양한 사례를 살펴보면, 인공지능이 어떻게 작동하는지 더 쉽게 이해할 수 있어요.",
      "study": "일상 사례로 데이터의 개념을 정립하고 텍스트, 이미지 등 형태별 분류 기준을 학습합니다. 직접 데이터를 분류하는 퀴즈를 통해 데이터의 속성을 직관적으로 이해하도록 구성된 활동입니다.",
      "url": "http://s.senaidl.kr/QYgV5",
      "qr": "2026-e-4-4.png"
    },
    {
      "order": 12,
      "code": "a",
      "q_no": 4,
      "module": 1,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능의 성능과 정확도는 학습하는 데이터의 품질에 의해 결정돼요. 만약 왜곡되거나 편향된 데이터, 혹은 오류가 많은 데이터를 학습한다면 인공지능 역시 잘못된 결과를 도출하게 됩니다. 인공지능이 올바르게 작동하기 위해서는 공정하고 객관적이며 신뢰할 수 있는 데이터를 선별하는 과정이 필수예요.",
      "study": "인공지능이 데이터 패턴 분석을 통해 문제를 해결하는 과정을 알아보고, ‘데이터 필란트로피’ 사례를 통해 데이터가 사회에 기여하는 모습을 살펴봅니다. 데이터를 바르게 활용해 세상을 돕는 데이터 히어로가 되겠다는 다짐을 해봅시다.",
      "url": "http://s.senaidl.kr/wb4BV",
      "qr": "2026-e-1-4.png"
    },
    {
      "order": 13,
      "code": "a",
      "q_no": 24,
      "module": 5,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "생성형 인공지능은 그림을 그리거나 이야기를 만들어낼 수 있어요. 우리가 입력한 문장(프롬프트)에 따라 새로운 것을 만들어주는 것이 특징이에요. 생성형 인공지능이 할 수 있는 일을 알면, 다양한 방법으로 활용할 수 있을 거예요.",
      "study": "사람은 마음과 의도를 담아 창작하지만 AI는 수많은 데이터를 조합해 그럴듯한 패턴을 찾아냅니다. AI가 문장의 의미를 직접 이해하는 대신 데이터 속 통계적 확률에 따라 다음에 올 단어나 이미지를 생성하는 원리를 살펴봅니다. 인공지능이 결과물을 만들어내는 과학적 과정을 이해하며 기술의 본질을 탐구하는 활동입니다.",
      "url": "http://s.senaidl.kr/S7fTz",
      "qr": "2026-e-5-1.png"
    },
    {
      "order": 14,
      "code": "a",
      "q_no": 8,
      "module": 2,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "인공지능은 많은 데이터를 보고 규칙을 배우는 방식으로 작동해요. 예를 들어, 스팸 메일을 걸러내거나 추천 영상을 보여주는 것도 인공지능의 원리를 이용한 거예요. 다양한 사례를 살펴보면, 인공지능이 어떻게 작동하는지 더 쉽게 이해할 수 있어요.",
      "study": "일상 사례로 데이터의 개념을 정립하고 텍스트, 이미지 등 형태별 분류 기준을 학습합니다. 직접 데이터를 분류하는 퀴즈를 통해 데이터의 속성을 직관적으로 이해하도록 구성된 활동입니다.",
      "url": "http://s.senaidl.kr/QYgV5",
      "qr": "2026-e-2-2.png"
    },
    {
      "order": 15,
      "code": "c",
      "q_no": 11,
      "module": 2,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "인공지능은 우리에게 편리함을 주기도 하지만, 개인정보 침해나 일자리 변화 같은 새로운 고민거리를 주기도 해요. 뉴스나 책을 읽을 때 기술이 주는 이점과 문제점 양쪽 모두 생각해보는 연습을 해보세요. 기술의 좋은 점과 나쁜 점을 균형 있게 바라볼 때 훌륭한 디지털 시민이 될 수 있어요.",
      "study": "인공지능의 두 얼굴'은 인공지능 기술로 변화된 생활 모습을 학습하는 활동입니다. 인공지능의 좋은 영향, 나쁜 영향을 담은 만화를 보고, 제시된 단어를 활용해 정리합니다. 이를 통해 인공지능의 양면성에 대해 알아볼 수 있습니다.",
      "url": "http://s.senaidl.kr/PHILp",
      "qr": "2026-e-2-5.png"
    },
    {
      "order": 16,
      "code": "b",
      "q_no": 2,
      "module": 1,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "인공지능은 확률과 통계를 기반으로 문장을 생성하므로 사실이 아닌 정보를 진실인 것처럼 이야기하기도 합니다. 인공지능이 제공하는 정보는 탐구를 위한 참고 자료일 뿐, 최종적인 사실 판단과 책임은 우리가 해야 합니다. 인공지능의 결과물을 대할 때 항상 '객관적 사실에 부합하는가?'라는 비판적 의문을 가져보세요.",
      "study": "만화 형식의 3가지 에피소드(독후감 쓰기, 식물 조사, 동네 조사)를 통해 학습 상황에서 AI·디지털 도구 활용 시 발생할 수 있는 문제를 살펴보고, 다짐 체크리스트 작성을 통해 정보를 비판적으로 확인하는 태도를 기를 수 있습니다.",
      "url": "http://s.senaidl.kr/Gjx66",
      "qr": "2026-e-1-2.png"
    },
    {
      "order": 17,
      "code": "d",
      "q_no": 13,
      "module": 3,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "사람과 인공지능이 함께 일하면 더 좋은 결과를 낼 수 있어요. 예를 들어, 의사가 병을 진단할 때 인공지능이 도움을 주거나, 음악을 만들 때 인공지능이 아이디어를 줄 수도 있어요. 인공지능과 함께 일해야 할 때에는 사람이 해야 하는 부분과 인공지능이 해야 하는 부분을 생각해보아야 해요.",
      "study": "친숙한 만화 설정을 통해 AI와의 올바른 협업 태도를 탐구합니다. AI의 답변을 맹목적으로 수용하기보다 비판적으로 사고하고 스스로 결정하는 '주체적인 나'의 역할을 이해합니다. 활동을 통해 AI의 한계를 인식하고 책임감 있는 활용 약속을 정하며, 기술과 지혜롭게 공존하는 미래 핵심 역량을 기릅니다.",
      "url": "http://s.senaidl.kr/lvXKW",
      "qr": "2026-e-3-1.png"
    },
    {
      "order": 18,
      "code": "d",
      "q_no": 22,
      "module": 4,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "지속가능한 발전을 위해 AI를 활용하면 많은 데이터를 빠르게 분석해서 문제를 더 정확하게 이해하고 해결 방법을 찾는 데 도움을 줄 수 있어요. 예를 들어 무인카메라로 멸종위기생물의 서식지를 파악하고 보호하거나 큰 산불 뒤에 AI가 데이터를 분석해 피해가 심한 구역을 빠르게 추정해서 도울 수 있어요.",
      "study": "일상 속 실례를 통해 AI의 개념을 발견하고, 실제 장면 속 AI 요소를 찾아보며 디지털 문해력을 높입니다. 직접 경험한 사례를 공유하며 AI와의 협업 윤리를 퀴즈로 재미있게 익힙니다. AI와 함께하는 하루를 성찰하며 기술과 조화롭게 공존하는 태도를 기르고 실천 역량을 함양합니다.",
      "url": "http://s.senaidl.kr/E09Aw",
      "qr": "2026-e-4-5.png"
    },
    {
      "order": 19,
      "code": "c",
      "q_no": 17,
      "module": 3,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "인공지능이 추천해 준 글을 읽고 틀린 내용은 없는지 직접 검토하거나, 내 숙제 목적에 맞게 질문을 바꾸어 가며 결과를 수정하는 행동이 주체적인 실천이에요. 앞으로 인공지능을 사용할 때는 인공지능의 의견을 무조건 따르기보다 고민하고 스스로 판단하여 활용하는 연습을 하세요.",
      "study": "초등 고학년 학생들이 인공지능 사용 과정에서 발생할 수 있는 과의존, 저작권, 딥페이크 문제를 사례와 선택형 활동으로 학습하며, 안전하고 주체적인 디지털 시민 태도를 기르는 윤리 교육자료입니다.",
      "url": "http://s.senaidl.kr/buq3X",
      "qr": "2026-e-3-5.png"
    },
    {
      "order": 20,
      "code": "a",
      "q_no": 3,
      "module": 1,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능이 완성되기 위해서는 '데이터 수집 → 데이터 전처리 및 가공 → 모델 학습 → 성능 평가'라는 체계적인 과정을 거쳐야 합니다. 인공지능을 탐구할 때는 기술 그 자체뿐만 아니라, 데이터가 수집되어 인공지능의 지식으로 변환되는 전체적인 흐름과 각 단계별 데이터의 역할을 파악하려는 노력이 필요합니다.",
      "study": "우리만 공부하는 것이 아니에요! AI 스피커의 사례를 통해 인공지능이 데이터 수집, 전처리, 라벨링, 예측의 과정을 거치며 학습하는 모습을 알아봅니다. 수많은 데이터 속에서 인공지능이 어떻게 배우고 판단하는지 살펴봅니다.",
      "url": "http://s.senaidl.kr/kvdgN",
      "qr": "2026-e-1-3.png"
    },
    {
      "order": 21,
      "code": "a",
      "q_no": 9,
      "module": 2,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능은 많은 데이터를 보고 규칙을 배우는 방식으로 작동해요. 예를 들어, 스팸 메일을 걸러내거나 추천 영상을 보여주는 것도 인공지능의 원리를 이용한 거예요. 다양한 사례를 살펴보면, 인공지능이 어떻게 작동하는지 더 쉽게 이해할 수 있어요.",
      "study": "일상 사례로 데이터의 개념을 정립하고 텍스트, 이미지 등 형태별 분류 기준을 학습합니다. 직접 데이터를 분류하는 퀴즈를 통해 데이터의 속성을 직관적으로 이해하도록 구성된 활동입니다.",
      "url": "http://s.senaidl.kr/QYgV5",
      "qr": "2026-e-2-3.png"
    },
    {
      "order": 22,
      "code": "a",
      "q_no": 20,
      "module": 4,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능이 만들어지려면 많은 데이터가 필요해요. 데이터를 모으고, 정리하고, 학습시키는 과정이 중요해요. 인공지능 학습 모델을 만들고 나면 인공지능 모델이 제대로 학습했는지 확인해야 해요. 그리고 나서 인공지능 모델을 사용할지 더 학습시킬지 결정해요.",
      "study": "일상 속 친숙한 사례를 통해 데이터의 개념을 명확히 정립합니다. 텍스트, 이미지 등 형태에 따른 분류 기준을 익히고 데이터를 분류해 보는 퀴즈를 통해 데이터의 속성을 이해할 수 있도록 구성했습니다. 정보를 체계적으로 관리하고 활용하는 데이터 문해력의 기초를 다지는 체험 중심의 학습 활동입니다.",
      "url": "http://s.senaidl.kr/QYgV5",
      "qr": "2026-e-4-3.png"
    },
    {
      "order": 23,
      "code": "a",
      "q_no": 19,
      "module": 4,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "인공지능은 데이터를 기반으로 학습하고 결정을 내려요. 예를 들어, 날씨 데이터를 모아 비 오는 날과 맑은 날의 패턴을 찾거나, 좋아하는 음식의 영양 정보를 비교해 건강한 식단을 만들 수도 있어요. 우리도 일상에서 데이터를 모으고 분석하는 연습을 하면, 인공지능이 어떻게 작동하는지 더 잘 이해할 수 있어요.",
      "study": "일상 속 친숙한 사례로 데이터의 개념을 정립하고, 텍스트와 이미지 등 형태별 분류 기준을 체계적으로 학습합니다. 특히 직접 데이터를 분류해 보는 실습형 퀴즈를 통해 데이터의 핵심 속성을 직관적으로 파악할 수 있도록 구성된 활동입니다. 이를 통해 데이터 문해력을 기를 수 있습니다.",
      "url": "http://s.senaidl.kr/QYgV5",
      "qr": "2026-e-4-2.png"
    },
    {
      "order": 24,
      "code": "b",
      "q_no": 29,
      "module": 5,
      "module_no": 6,
      "allCorrect": false,
      "feedback": "의료, 농업, 교통 등 다양한 분야에서 인공지능이 활용되고 있어요. 예를 들어, 농장에서 인공지능이 작물이 잘 자라는 환경을 분석하거나, 공장에서 불량품을 찾아내는 데 사용될 수도 있어요.",
      "study": "생성형 AI로 만든 글 등 실제 창작 사례를 살펴보며 기술의 가능성을 탐구합니다. 콘텐츠 제작 과정에서 AI가 주는 편리함과 창의적 영감이라는 장점, 그리고 저작권이나 왜곡 문제 같은 한계를 비교·분석합니다. 생성형 AI의 특성을 정확히 이해하고, 목적에 맞게 도구를 활용하는 비판적 제작 능력을 기르는 활동입니다.",
      "url": "http://s.senaidl.kr/OFVXh",
      "qr": "2026-e-5-6.png"
    },
    {
      "order": 25,
      "code": "d",
      "q_no": 25,
      "module": 5,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "지속가능한 발전을 위해 AI를 활용하면 많은 데이터를 빠르게 분석해서 문제를 더 정확하게 이해하고 해결 방법을 찾는 데 도움을 줄 수 있어요. 예를 들어 무인카메라로 멸종위기생물의 서식지를 파악하고 보호하거나 큰 산불 뒤에 AI가 데이터를 분석해 피해가 심한 구역을 빠르게 추정해서 도울 수 있어요.",
      "study": "일상 속 실례를 통해 AI의 개념을 발견하고, 실제 장면 속 AI 요소를 찾아보며 디지털 문해력을 높입니다. 직접 경험한 사례를 공유하며 AI와의 협업 윤리를 퀴즈로 재미있게 익힙니다. AI와 함께하는 하루를 성찰하며 기술과 조화롭게 공존하는 태도를 기르고 실천 역량을 함양합니다.",
      "url": "http://s.senaidl.kr/tG3tS",
      "qr": "2026-e-5-2.png"
    },
    {
      "order": 26,
      "code": "b",
      "q_no": 27,
      "module": 5,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능과 디지털 도구를 활용하면 누구나 쉽게 나만의 콘텐츠를 만들 수 있어요. 예를 들어, 인공지능에게 주제를 말해 음악을 작곡하거나, 내가 그린 스케치를 멋진 그림으로 완성하는 것 등이 모두 제작 체험이에요. 인공지능 도구의 특징을 이해하고 사용해 내 생각을 글, 그림, 소리, 영상 등으로 직접 만들어보는 연습을 하세요.",
      "study": "만화를 통해 대표적인 AI·디지털 도구의 종류를 살펴보고 각각의 장점과 단점을 쉽게 알아볼 수 있습니다. 또한, 사용시 지켜야 할 점에 대하여 알아보고 AI·디지털 도구 사용시의 주의점에 대하여 학습할 수 있습니다.",
      "url": "http://s.senaidl.kr/ry82O",
      "qr": "2026-e-5-4.png"
    },
    {
      "order": 27,
      "code": "d",
      "q_no": 7,
      "module": 2,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "사람과 인공지능이 함께 일하면 더 좋은 결과를 낼 수 있어요. 예를 들어, 의사가 병을 진단할 때 인공지능이 도움을 주거나, 음악을 만들 때 인공지능이 아이디어를 줄 수도 있어요. 인공지능과 함께 일해야 할 때에는 사람이 해야 하는 부분과 인공지능이 해야 하는 부분을 생각해보아야 해요.",
      "study": "친숙한 만화 설정을 통해 AI와의 올바른 협업 태도를 탐구합니다. AI의 답변을 맹목적으로 수용하기보다 비판적으로 사고하고 스스로 결정하는 '주체적인 나'의 역할을 이해합니다. 활동을 통해 AI의 한계를 인식하고 책임감 있는 활용 약속을 정하며, 기술과 지혜롭게 공존하는 미래 핵심 역량을 기릅니다.",
      "url": "http://s.senaidl.kr/lvXKW",
      "qr": "2026-e-2-1.png"
    },
    {
      "order": 28,
      "code": "d",
      "q_no": 10,
      "module": 2,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "코딩은 나의 생각을 컴퓨터가 이해할 수 있도록 번역하는 과정입니다. 이를 위해 나의 아이디어가 어떤 순서로 움직여야 하는지 먼저 쪼개어 정리해보는 단계가 필요해요. 인공지능 도구나 블록 코딩의 기능을 활용할 때 각 명령어가 나의 생각을 정밀하게 구현하고 있는지 논리적인 흐름을 점검해 보세요.",
      "study": "일상 속 친숙한 사례를 통해 인공지능의 개념과 활용 모습을 탐구합니다. AI가 사라진 세상을 상상하며 그 필요성과 영향을 성찰하고, 기술이 인간을 향해야 한다는 '인간중심 AI'의 가치를 배웁니다. 나아가 사람에게 도움을 주는 창의적인 AI 아이디어를 설계하며 미래 공존 역량을 키웁니다.",
      "url": "http://s.senaidl.kr/tG3tS",
      "qr": "2026-e-2-4.png"
    },
    {
      "order": 29,
      "code": "b",
      "q_no": 16,
      "module": 3,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능과 디지털 도구는 우리 주변의 불편한 문제를 해결할 때 유용하게 쓰여요. 문제를 풀거나 탐구할 때는 '내가 겪는 일상 속 불편함을 어떤 디지털 도구로 해결할 수 있을까?'를 먼저 생각하고, 그 해결 순서를 차근차근 계획해보세요. 기술을 사용해 문제를 해결하는 구체적인 과정을 떠올려보는 것이 중요합니다.",
      "study": "사례를 다양한 디지털 플랫폼을 활용하여 문제를 해결하는 방법과 그 과정을 검증하는 방법을 학습합니다. 우리가 겪는 다양한 사례를 디지털 기기를 사용하여 해결할 수 있음을 경험적으로 알 수 있도록 구성하였습니다.",
      "url": "http://s.senaidl.kr/3y7Nr",
      "qr": "2026-e-3-4.png"
    },
    {
      "order": 30,
      "code": "a",
      "q_no": null,
      "module": null,
      "module_no": 1,
      "allCorrect": true,
      "feedback": "인공지능의 개념과 원리를 잘 이해하고 있으며, 다양한 사례를 통해 인공지능이 어떻게 활용되는지 폭넓게 학습하였습니다. 앞으로도 인공지능의 발전과 활용 방안에 관심을 가지고 지속적으로 탐구해 보시기 바랍니다.",
      "study": "전통적 프로그래밍과 기계학습의 차이를 비교하고 지도·비지도·강화학습의 원리를 알아봅니다. 스스로 규칙을 찾는 AI의 학습 방식을 탐구하며 인공지능 기초 소양을 기르는 활동입니다.",
      "url": "http://s.senaidl.kr/dUsep",
      "qr": "2026-e-a-1.png"
    },
    {
      "order": 31,
      "code": "b",
      "q_no": null,
      "module": null,
      "module_no": 2,
      "allCorrect": true,
      "feedback": "인공지능이 생활 속에서 어떻게 사용되는지 깊이 이해하고 있으며, 이를 문제 해결에 적용하는 능력이 뛰어납니다. 앞으로는 다양한 인공지능 도구를 직접 활용해 보고, 이를 실생활과 학습에 적극적으로 적용해 보시길 바랍니다.",
      "study": "우리 주변에서 겪을 수 있는 실생활 문제를 해결하는 과정에서 AI 디지털 도구가 어떤 도움을 주는지, 학교 활동과 연계하여 자연스럽게 느낄수 있도록 구성하였습니다.",
      "url": "http://s.senaidl.kr/jKSuK",
      "qr": "2026-e-a-2.png"
    },
    {
      "order": 32,
      "code": "c",
      "q_no": null,
      "module": null,
      "module_no": 3,
      "allCorrect": true,
      "feedback": "인공지능을 사용할 때 윤리적인 관점을 고려하며, 개인정보 보호와 공정한 AI 활용의 중요성을 잘 이해하고 있습니다. 앞으로도 인공지능을 안전하고 책임감 있게 사용하며, 이를 통해 더욱 발전된 사고력을 기를 수 있도록 노력해 보시기 바랍니다.",
      "study": "AI 탐정단 두 얼굴의 도시를 구해라!' 는 학생들이 주변에서 쉽게 접할 수 있는 상황에서 인공지능의 이로운 점, 해로운 점을 스스로 생각해 보고 기술의 양면성을 파악하려는 자세를 가질 수 있도록 돕는 교육 자료 입니다.",
      "url": "http://s.senaidl.kr/C8NRK",
      "qr": "2026-e-a-3.png"
    },
    {
      "order": 33,
      "code": "d",
      "q_no": null,
      "module": null,
      "module_no": 4,
      "allCorrect": true,
      "feedback": "인공지능은 우리 일을 도와주는 유용한 도구로, 잘 활용하면 삶이 훨씬 편리해집니다. 하지만 사용하기 전에 우리가 직접 해야 할 일과 인공지능에게 맡겨도 될 일을 잘 구분해야 합니다. 인공지능과 어떤 사이가 되는 것이 좋을지 한번 곰곰이 생각해보세요.",
      "study": "기술의 편리함 너머 인간 중심 AI 윤리를 탐구하는 교육 자료입니다. 자율주행 로봇과 키오스크 사례로 공정성·포용성 등의 가치를 비판적으로 분석하고 '착한 AI' 설계를 통해 따뜻한 디지털 시민성을 확립합니다.",
      "url": "http://s.senaidl.kr/2f7lz",
      "qr": "2026-e-a-4.png"
    }
  ],
  "m": [
    {
      "order": 1,
      "code": "c",
      "q_no": 5,
      "module": 1,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "인공지능을 활용할 때에는 목적에 맞게 적절한 도구를 선택하고, 사용 과정을 스스로 통제하며 주도적으로 활용할 수 있어야 합니다. 또한, 인공지능의 결과를 그대로 수용하지 않고, 비판적으로 검토하여 필요에 따라 인공지능의 결과를 수정 또는 거부하는 판단력도 매우 중요합니다.",
      "study": "간단한 만화를 바탕으로 그래프가 정보를 조작하여 제시하는 경우나 인공지능의 환각의 예시를 보고 인공지능에게 질문하거나 인공지능에게 자료를 요청할 때는 제시된 자료를 비판적으로 수용하고 교차 검토가 필요함을 학습합니다.",
      "url": "http://s.senaidl.kr/85oUi",
      "qr": "2026-m-1-5.png"
    },
    {
      "order": 2,
      "code": "a",
      "q_no": 14,
      "module": 3,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능은 주어진 데이터를 분석하고, 학습을 통해 패턴을 찾아 결과를 도출해요. 예를 들어, 온라인 쇼핑몰의 추천 시스템은 사용자의 구매 이력을 분석하여 관심 있을 만한 상품을 추천해요. 이런 원리를 이해하면, 인공지능이 어떻게 작동하는지 더 쉽게 파악할 수 있어요.",
      "study": "추천 알고리즘이란 무엇인지 알아보고 실생활에서 사용되는 다양한 추천 알고리즘의 종류를 알아봅니다. 추천 알고리즘의 대표적 알고리즘인 협업 필터링에 대해 알아보고 예제와 함께 이해를 확인해봅니다.",
      "url": "http://s.senaidl.kr/C0m4D",
      "qr": "2026-m-3-4.png"
    },
    {
      "order": 3,
      "code": "a",
      "q_no": 6,
      "module": 2,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "인공지능은 영화 추천 시스템, 날씨 예측 시스템, 의료 진단 시스템, 자율주행 자동차 등 우리 생활 곳곳에 활용되고 있습니다. 다양한 사례를 통해 인공지능이 하는 일(예측, 분석, 추천, 생성)의 종류와 특징을 파악해 보세요.",
      "study": "일상 사례로 예측 알고리즘을 이해하고 패턴 찾기 게임과 시뮬레이션으로 원리를 체험합니다. 데이터에 따른 결과 변화를 확인하며 인공지능의 예측 과정을 쉽고 재미있게 익히는 탐구 활동입니다.",
      "url": "http://s.senaidl.kr/r3WP8",
      "qr": "2026-m-2-1.png"
    },
    {
      "order": 4,
      "code": "c",
      "q_no": 15,
      "module": 3,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "인공지능의 성능 향상과 개인정보 보호는 정답이 없는 가치 충돌의 문제예요. 기술의 효율성만 쫓기보다 우리 사회가 더 중요하게 지켜야 할 가치가 무엇인지 고민하며 균형을 잡는 태도가 필요해요.",
      "study": "인공지능 윤리적 딜레마의 개념을 학습하는 활동입니다. 인공지능 자율 주행 자동차와 관련된 의사 결정 과정을 직접 경험함으로써 인공지능으로 인해 윤리적 딜레마가 발생할 수 있다는 것을 이해하는 것을 목표로 합니다.",
      "url": "http://s.senaidl.kr/cZTYA",
      "qr": "2026-m-3-5.png"
    },
    {
      "order": 5,
      "code": "b",
      "q_no": 19,
      "module": 4,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능은 그림을 그리거나 음악을 만드는 등 다양한 창작 활동에 활용될 수 있어요. 특히 그리고 싶은 대상, 스타일, 분위기를 구체적으로 설명하여 인공지능에 전달하면 원하는 결과에 더 가까운 작품을 만들 수 있어요.",
      "study": "생성형 AI로 글과 그림을 만드는 실제 사례를 살펴봅니다. 아이디어를 멋지게 시각화하는 인공지능의 장점과 저작권 및 창의성 논란 같은 한계를 꼼꼼히 비교해 봅니다. 인공지능의 특징을 이해하면 상상력을 현실로 만드는 도구로 멋지게 활용할 수 있습니다.",
      "url": "http://s.senaidl.kr/OFVXh",
      "qr": "2026-m-4-4.png"
    },
    {
      "order": 6,
      "code": "a",
      "q_no": 11,
      "module": 3,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "기계학습의 성능은 데이터에 크게 좌우됩니다. 다양한 사례를 통해 데이터의 품질과 편향이 기계학습에 미치는 영향을 이해하고, 사용된 데이터의 출처, 품질, 편향 등을 종합적으로 평가하는 역량을 길러보세요.",
      "study": "데이터는 어떻게 수집할 수 있고 데이터의 유형에 따라 적절한 데이터 수집 방법이 무엇인지 알아봅니다. 또한 수집된 데이터에서 이상이 있거나 값이 없을 때 어떻게 처리해야 하는지 알아봅니다. 구체적인 예시를 통해 이해를 확인해봅니다.",
      "url": "http://s.senaidl.kr/SxNTa",
      "qr": "2026-m-3-1.png"
    },
    {
      "order": 7,
      "code": "a",
      "q_no": 17,
      "module": 4,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "인공지능은 편리한 기술이지만 늘 좋은 것만은 아니에요. 빠르게 정보를 찾고 글과 그림을 만들 수 있지만 가짜 뉴스나 편향된 내용이 함께 퍼질 수도 있어요. 특히 인공지능 결과물은 그럴듯해 보여도 거짓이나 오류를 포함할 수 있으니 바로 믿지 말고 출처를 확인하고 여러 자료와 비교해 꼭 점검해야 해요.",
      "study": "<생성형 AI, 무조건 믿어도 될까?> 웹 앱은 AI의 환각과 편향성을 이해하고, 3단계 팩트체크로 숨은 오류를 찾아내는 'AI 탐정단' 훈련을 목표로 합니다. 비판적 시각을 기르고 책임감 있는 활용을 다짐해 보세요.",
      "url": "http://s.senaidl.kr/FYtuH",
      "qr": "2026-m-4-2.png"
    },
    {
      "order": 8,
      "code": "b",
      "q_no": 4,
      "module": 1,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "AI·디지털 도구를 활용해 다양한 방식으로 학습 내용을 심화하고 탐구해 보세요. 그리고, AI·디지털 도구를 선택 및 활용하는 과정에서 실제로 학습에 어떻게 도움이 되었는지 성찰해 보시기 바랍니다.",
      "study": "AI·디지털 학습 유형별 대표적인 학습 도구를 직접 확인하고 간단히 체험해 볼 수 있는 웹앱 교육 자료로, 학생이 스스로 기능을 체험하여 유형별 학습 도구의 특징을 이해하고 활용할 수 있도록 돕습니다.",
      "url": "http://s.senaidl.kr/n7ZMz",
      "qr": "2026-m-1-4.png"
    },
    {
      "order": 9,
      "code": "c",
      "q_no": 7,
      "module": 2,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "인공지능을 사용할 때에는 자신의 정보뿐만 아니라 타인의 개인정보와 프라이버시도 존중해야 해요. 인공지능 서비스를 이용할 때에는 어떤 정보가 수집·활용되는지 꼼꼼히 확인하고, 필요한 정보만 신중하게 입력해야 해요. 이러한 주의는 인공지능을 안전하고 책임 있게 활용하는 출발점이 됩니다.",
      "study": "체크리스트를 통해 인공지능 사용 습관을 점검해 봅니다. 이후 책임감 있는 인공지능 사용 방법 영상을 시청하고, 학습지의 점검 문제를 풀어보면서 책임감 있는 인공지능 사용에 대한 글을 남기며 실천을 다짐합니다.",
      "url": "http://s.senaidl.kr/oUzH4",
      "qr": "2026-m-2-2.png"
    },
    {
      "order": 10,
      "code": "a",
      "q_no": 23,
      "module": 5,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "기계학습 모델은 데이터 수집 → 데이터 학습 → 예측과 판단의 과정을 거쳐 만들어져요. 먼저 충분한 데이터를 모으고, 이를 바탕으로 특정 패턴을 학습한 후, 새로운 데이터를 입력하면 결과를 예측해요. 이 과정을 이해하면 기계학습을 활용한 다양한 프로젝트를 설계하고 구현할 수 있어요.",
      "study": "데이터는 어떻게 수집할 수 있고 데이터의 유형에 따라 적절한 데이터 수집 방법이 무엇인지 알아봅니다. 또한 수집된 데이터에서 이상이 있거나 값이 없을 때 어떻게 처리해야 하는지 알아봅니다. 구체적인 예시를 통해 이해를 확인해봅니다.",
      "url": "http://s.senaidl.kr/SxNTa",
      "qr": "2026-m-5-3.png"
    },
    {
      "order": 11,
      "code": "c",
      "q_no": 26,
      "module": 5,
      "module_no": 6,
      "allCorrect": false,
      "feedback": "인공지능이 생성한 결과물은 항상 정확하지 않을 수 있어요. 그래서 인공지능의 결과를 그대로 사용하기보다, 편향되거나 부적절한 부분이 있는지 비판적으로 살펴보고 책임 있게 판단하는 태도가 중요해요.",
      "study": "AI가 제공한 답변의 정확성에 대해 생각해보고, 여러 상황을 통해 AI가 제시하는 결과에 대한 생각을 나눕니다. 이를 바탕으로 AI가 생성한 결과물은 출처 확인, 개인정보보호, 결과에 대한 책임이 필요함을 내면화하게 됩니다.",
      "url": "http://s.senaidl.kr/pd4G1",
      "qr": "2026-m-5-6.png"
    },
    {
      "order": 12,
      "code": "b",
      "q_no": 3,
      "module": 1,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능을 활용하여 학습을 할 때에는 학습 목적에 맞는 AI·디지털 도구를 선택하고, 학습 맥락에 적절한 기능을 활용하는 것이 중요합니다. AI·디지털 도구를 활용한 학습문제 해결 사례를 살펴보고, 효과적인 활용 방식을 탐색해보세요.",
      "study": "AI·디지털 학습 유형을 나누어 소개하고, 학생 스스로 성향을 파악해 자신에게 가장 잘 맞는 학습 유형과 전략을 추천해 주는 맞춤형 안내 자료로, 효과적인 AI·디지털 학습 방향을 찾도록 돕습니다.",
      "url": "http://s.senaidl.kr/aTsaH",
      "qr": "2026-m-1-3.png"
    },
    {
      "order": 13,
      "code": "c",
      "q_no": 25,
      "module": 5,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "인공지능의 성능 향상과 개인정보 보호는 정답이 없는 가치 충돌의 문제예요. 기술의 효율성만 쫓기보다 우리 사회가 더 중요하게 지켜야 할 가치가 무엇인지 고민하며 균형을 잡는 태도가 필요해요.",
      "study": "인공지능 윤리적 딜레마의 개념을 학습하는 활동입니다. 인공지능 자율 주행 자동차와 관련된 의사 결정 과정을 직접 경험함으로써 인공지능으로 인해 윤리적 딜레마가 발생할 수 있다는 것을 이해하는 것을 목표로 합니다.",
      "url": "http://s.senaidl.kr/cZTYA",
      "qr": "2026-m-5-5.png"
    },
    {
      "order": 14,
      "code": "b",
      "q_no": 1,
      "module": 1,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "인공지능은 나에게 맞춤형 정보를 추천해줄 수 있어요. 예를 들어 인공지능은 내가 시청했던 영상 기록을 토대로 내 취향에 맞는 영상을 추천해줍니다. 그러나 인공지능이 추천한 결과를 그대로 따르기보다 추천 목록과 원인을 꼼꼼히 살펴보고, 나에게 맞는 추천 결과인지 검토해 볼 필요가 있습니다.",
      "study": "텍스트AI, 이미지AI, 추천 알고리즘에 대해 자연스럽게 접할 수 있도록 구성하였습니다. 학교 홍보내용을 통해 새로운 기술에 유연하게 적응하는 내용을 담았습니다.",
      "url": "http://s.senaidl.kr/HuqJr",
      "qr": "2026-m-1-1.png"
    },
    {
      "order": 15,
      "code": "c",
      "q_no": 18,
      "module": 4,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능이 생성한 결과물은 항상 정확하지 않을 수 있어요. 그래서 인공지능의 결과를 그대로 사용하기보다, 편향되거나 부적절한 부분이 있는지 비판적으로 살펴보고 책임 있게 판단하는 태도가 중요해요.",
      "study": "AI가 제공한 답변의 정확성에 대해 생각해보고, 여러 상황을 통해 AI가 제시하는 결과에 대한 생각을 나눕니다. 이를 바탕으로 AI가 생성한 결과물은 출처 확인, 개인정보보호, 결과에 대한 책임이 필요함을 내면화하게 됩니다.",
      "url": "http://s.senaidl.kr/pd4G1",
      "qr": "2026-m-4-3.png"
    },
    {
      "order": 16,
      "code": "b",
      "q_no": 16,
      "module": 4,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "생성형 인공지능을 사용하려면 프롬프트를 잘 작성해야 해요. 예를 들어, 그림 생성 인공지능에 \"새\"라고 입력하는 것보다는 \"초록색 숲에서 노래하는 새\"라고 입력하면 이에 맞는 이미지를 생성할 수 있어요. 만약 생성한 이미지가 원하는 결과물과 다르다면 프롬프트를 수정하거나 피드백을 입력해야 해요.",
      "study": "내가 만들고 싶은 콘텐츠를 계획한 뒤 이를 생성할 수 있는 프롬프트 작성 방법을 단계적으로 안내하여 AI · 디지털 도구를 통하여 자신만의 콘텐츠를 창작해 볼 수 있습니다.",
      "url": "http://s.senaidl.kr/X4J59",
      "qr": "2026-m-4-1.png"
    },
    {
      "order": 17,
      "code": "c",
      "q_no": 20,
      "module": 4,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "인공지능을 활용할 때에는 목적에 맞게 적절한 도구를 선택하고, 사용 과정을 스스로 통제하며 주도적으로 활용할 수 있어야 합니다. 또한, 인공지능의 결과를 그대로 수용하지 않고, 비판적으로 검토하여 필요에 따라 인공지능의 결과를 수정 또는 거부하는 판단력도 매우 중요합니다.",
      "study": "간단한 만화를 바탕으로 그래프가 정보를 조작하여 제시하는 경우나 인공지능의 환각의 예시를 보고 인공지능에게 질문하거나 인공지능에게 자료를 요청할 때는 제시된 자료를 비판적으로 수용하고 교차 검토가 필요함을 학습합니다.",
      "url": "http://s.senaidl.kr/85oUi",
      "qr": "2026-m-4-5.png"
    },
    {
      "order": 18,
      "code": "d",
      "q_no": 13,
      "module": 3,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능은 카메라나 거리 측정 센서와 같은 다양한 센서를 활용해 주변 환경을 인식해요. 이러한 기능을 활용하면 교통 안전이나 에너지 절약과 같은 지속 가능한 사회의 문제를 해결하는 방법을 구상할 수 있어요. 직접 프로그래밍을 통해 센서를 활용하면, 인공지능의 원리를 더 쉽게 이해할 수 있어요.",
      "study": "기술의 편리함 너머 인간 중심 AI 윤리를 탐구하는 교육 자료입니다. 자율주행 로봇과 키오스크 사례로 공정성·포용성 등의 가치를 비판적으로 분석하고 '착한 AI' 설계를 통해 따뜻한 디지털 시민성을 확립합니다.",
      "url": "http://s.senaidl.kr/2f7lz",
      "qr": "2026-m-3-3.png"
    },
    {
      "order": 19,
      "code": "d",
      "q_no": 8,
      "module": 2,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능은 카메라나 거리 측정 센서와 같은 다양한 센서를 활용해 주변 환경을 인식해요. 이러한 기능을 활용하면 교통 안전이나 에너지 절약과 같은 지속 가능한 사회의 문제를 해결하는 방법을 구상할 수 있어요. 직접 프로그래밍을 통해 센서를 활용하면, 인공지능의 원리를 더 쉽게 이해할 수 있어요.",
      "study": "다양한 분야에서 현재 인공지능과 인간이 협업하는 방식을 사례를 통해 이해합니다. 인간중심 협업 방법이 필요한 이유와 인공지능과의 현명한 공생 방법을 알아보며 현명한 인공지능 사용자로서의 태도를 다짐합니다.",
      "url": "http://s.senaidl.kr/nuk14",
      "qr": "2026-m-2-3.png"
    },
    {
      "order": 20,
      "code": "d",
      "q_no": 24,
      "module": 5,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능은 카메라나 거리 측정 센서와 같은 다양한 센서를 활용해 주변 환경을 인식해요. 이러한 기능을 활용하면 교통 안전이나 에너지 절약과 같은 지속 가능한 사회의 문제를 해결하는 방법을 구상할 수 있어요. 직접 프로그래밍을 통해 센서를 활용하면, 인공지능의 원리를 더 쉽게 이해할 수 있어요.",
      "study": "기술의 편리함 너머 인간 중심 AI 윤리를 탐구하는 교육 자료입니다. 자율주행 로봇과 키오스크 사례로 공정성·포용성 등의 가치를 비판적으로 분석하고 '착한 AI' 설계를 통해 따뜻한 디지털 시민성을 확립합니다.",
      "url": "http://s.senaidl.kr/2f7lz",
      "qr": "2026-m-5-4.png"
    },
    {
      "order": 21,
      "code": "b",
      "q_no": 21,
      "module": 5,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "번역이 필요할 때는 번역 AI, 길을 찾을 때는 내비게이션 AI처럼, 상황에 맞는 인공지능 도구를 활용하면 문제를 더 쉽게 해결할 수 있어요. 어떤 인공지능이 어떤 기능을 하는지 이해하면, 실생활에서 더욱 효과적으로 사용할 수 있어요.",
      "study": "이 카드뉴스를 활용하여 교통안전, 의료보건, 교육, 농업식품 분야에서 활용되는 인공지능과 데이터 기술 사례를 통해 AI가 사회 문제를 해결하고 우리의 삶을 더 안전하고 편리하게 만드는 과정을 이해할 수 있습니다.",
      "url": "http://s.senaidl.kr/IWcmZ",
      "qr": "2026-m-5-1.png"
    },
    {
      "order": 22,
      "code": "d",
      "q_no": 2,
      "module": 1,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "인공지능은 카메라나 거리 측정 센서와 같은 다양한 센서를 활용해 주변 환경을 인식해요. 이러한 기능을 활용하면 교통 안전이나 에너지 절약과 같은 지속 가능한 사회의 문제를 해결하는 방법을 구상할 수 있어요. 직접 프로그래밍을 통해 센서를 활용하면, 인공지능의 원리를 더 쉽게 이해할 수 있어요.",
      "study": "다양한 분야에서 현재 인공지능과 인간이 협업하는 방식을 사례를 통해 이해합니다. 인간중심 협업 방법이 필요한 이유와 인공지능과의 현명한 공생 방법을 알아보며 현명한 인공지능 사용자로서의 태도를 다짐합니다.",
      "url": "http://s.senaidl.kr/nuk14",
      "qr": "2026-m-1-2.png"
    },
    {
      "order": 23,
      "code": "a",
      "q_no": 9,
      "module": 2,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "생성형 인공지능은 방대한 데이터를 학습하여 새로운 콘텐츠를 만들어내는 방식으로 작동해요. 예를 들어, 그림 생성 AI는 기존 그림을 학습한 후, 새로운 그림을 그릴 수 있는 패턴을 찾아내요. 이런 원리를 이해하면, 생성형 인공지능을 더욱 효과적으로 활용할 수 있어요.",
      "study": "<생성형 AI에게 던지는 올바른 질문법> 웹 앱은 좋은 질문이 좋은 답을 만드는 원리를 배우고, 다양한 상황에서 최적의 프롬프트를 직접 골라보는 시뮬레이션입니다. AI 윤리 수칙까지 익혀 '프롬프트 마스터'에 도전해 보세요.",
      "url": "http://s.senaidl.kr/i0CVL",
      "qr": "2026-m-2-4.png"
    },
    {
      "order": 24,
      "code": "a",
      "q_no": 22,
      "module": 5,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "기계학습 모델은 데이터 수집 → 데이터 학습 → 예측과 판단의 과정을 거쳐 만들어져요. 먼저 충분한 데이터를 모으고, 이를 바탕으로 특정 패턴을 학습한 후, 새로운 데이터를 입력하면 결과를 예측해요. 이 과정을 이해하면 기계학습을 활용한 다양한 프로젝트를 설계하고 구현할 수 있어요.",
      "study": "데이터는 어떻게 수집할 수 있고 데이터의 유형에 따라 적절한 데이터 수집 방법이 무엇인지 알아봅니다. 또한 수집된 데이터에서 이상이 있거나 값이 없을 때 어떻게 처리해야 하는지 알아봅니다. 구체적인 예시를 통해 이해해봅니다.",
      "url": "http://s.senaidl.kr/SxNTa",
      "qr": "2026-m-5-2.png"
    },
    {
      "order": 25,
      "code": "b",
      "q_no": 12,
      "module": 3,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "번역이 필요할 때는 번역 AI, 길을 찾을 때는 내비게이션 AI처럼, 상황에 맞는 인공지능 도구를 활용하면 문제를 더 쉽게 해결할 수 있어요. 어떤 인공지능이 어떤 기능을 하는지 이해하면, 실생활에서 더욱 효과적으로 사용할 수 있어요.",
      "study": "이 카드뉴스를 활용하여 교통안전, 의료보건, 교육, 농업식품 분야에서 활용되는 인공지능과 데이터 기술 사례를 통해 AI가 사회 문제를 해결하고 우리의 삶을 더 안전하고 편리하게 만드는 과정을 이해할 수 있습니다.",
      "url": "http://s.senaidl.kr/IWcmZ",
      "qr": "2026-m-3-2.png"
    },
    {
      "order": 26,
      "code": "a",
      "q_no": 10,
      "module": 2,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "기계학습의 성능은 데이터에 크게 좌우됩니다. 다양한 사례를 통해 데이터의 품질과 편향이 기계학습에 미치는 영향을 이해하고, 사용된 데이터의 출처, 품질, 편향 등을 종합적으로 평가하는 역량을 길러보세요.",
      "study": "데이터는 어떻게 수집할 수 있고 데이터의 유형에 따라 적절한 데이터 수집 방법이 무엇인지 알아봅니다. 또한 수집된 데이터에서 이상이 있거나 값이 없을 때 어떻게 처리해야 하는지 알아봅니다. 구체적인 예시를 통해 이해해봅니다.",
      "url": "http://s.senaidl.kr/SxNTa",
      "qr": "2026-m-2-5.png"
    },
    {
      "order": 27,
      "code": "a",
      "q_no": null,
      "module": null,
      "module_no": 1,
      "allCorrect": true,
      "feedback": "인공지능의 개념과 원리를 잘 이해하고 있으며, 다양한 사례를 통해 인공지능이 어떻게 활용되는지 폭넓게 학습하였습니다. 앞으로도 인공지능의 발전과 활용 방안에 관심을 가지고 지속적으로 탐구해 보시기 바랍니다.",
      "study": "<생성형 AI에게 던지는 올바른 질문법> 웹 앱은 좋은 질문이 좋은 답을 만드는 원리를 배우고, 다양한 상황에서 최적의 프롬프트를 직접 골라보는 시뮬레이션입니다. AI 윤리 수칙까지 익혀 '프롬프트 마스터'에 도전해 보세요.",
      "url": "http://s.senaidl.kr/i0CVL",
      "qr": "2026-m-a-1.png"
    },
    {
      "order": 28,
      "code": "b",
      "q_no": null,
      "module": null,
      "module_no": 2,
      "allCorrect": true,
      "feedback": "인공지능이 생활 속에서 어떻게 사용되는지 깊이 이해하고 있으며, 이를 문제 해결에 적용하는 능력이 뛰어납니다. 앞으로는 다양한 인공지능 도구를 직접 활용해 보고, 이를 실생활과 학습에 적극적으로 적용해 보시길 바랍니다.",
      "study": "일상생활 속 AI 요청 사례를 통해 책임있는 사용과 그렇지 않은 사용을 구별하는 경험을 검토자역할을 통해 AI 사용에 따른 결과를 수익과 신뢰라는 지표를 통해 이해합니다. 게임을 통해 AI 윤리와 책임에 대한 이해를 목표로 합니다.",
      "url": "http://s.senaidl.kr/KccSP",
      "qr": "2026-m-a-2.png"
    },
    {
      "order": 29,
      "code": "c",
      "q_no": null,
      "module": null,
      "module_no": 3,
      "allCorrect": true,
      "feedback": "인공지능을 사용할 때 윤리적인 관점을 고려하며, 개인정보 보호와 공정한 AI 활용의 중요성을 잘 이해하고 있습니다. 앞으로도 인공지능을 안전하고 책임감 있게 사용하며, 이를 통해 더욱 발전된 사고력을 기를 수 있도록 노력해 보시기 바랍니다.",
      "study": "SNS 게시물 속 개인정보를 직접 찾아보며 정보 보호의 중요성을 체감합니다. 나와 타인의 정보까지 소중히 다루는 방법을 탐색하고, 일상 속 실천 방안을 배웁니다. 무심코 올린 사진이나 글의 위험성을 인지하고, 안전한 디지털 생활을 위해 스스로 정보를 지키는 책임감 있는 태도를 기르는 활동입니다.",
      "url": "http://s.senaidl.kr/1euWG",
      "qr": "2026-m-a-3.png"
    },
    {
      "order": 30,
      "code": "d",
      "q_no": null,
      "module": null,
      "module_no": 4,
      "allCorrect": true,
      "feedback": "인공지능은 우리 일을 도와주는 유용한 도구로, 잘 활용하면 삶이 훨씬 편리해집니다. 하지만 사용하기 전에 우리가 직접 해야 할 일과 인공지능에게 맡겨도 될 일을 잘 구분해야 합니다. 인공지능과 어떤 사이가 되는 것이 좋을지 한 번 곰곰이 생각해보세요.",
      "study": "AI의 편향성과 오류 사례를 통해 인간 중심 AI의 필요성을 이해합니다. 가상 시나리오 시뮬레이션으로 공정성·투명성 등 핵심 가치를 진단하고, 데이터 수정 및 인간의 개입을 포함한 리빌딩 과정을 통해 AI를 재설계합니다.",
      "url": "http://s.senaidl.kr/rVS0t",
      "qr": "2026-m-a-4.png"
    }
  ],
  "h": [
    {
      "order": 1,
      "code": "b",
      "q_no": 1,
      "module": 1,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "인공지능으로 문제를 해결하려면 먼저 무엇을 해결하고 싶은지 목적을 분명히 해야 해요. 인공지능 도구마다 잘하는 일이 다르기 때문에, 목적에 맞는 기능을 가진 도구를 골라야 해요. 여러 도구의 특징을 비교해 보면 상황에 가장 알맞은 인공지능을 선택하는 능력을 기를 수 있어요.",
      "study": "이 학습 자료를 활용하여 학교와 지역사회에서 발생하는 다양한 문제 상황을 해결하기 위해 적절한 AI 도구를 탐색하고, 그 선택 이유를 논리적으로 설명해 보며 문제 해결력과 비판적 사고력을 기를 수 있습니다.",
      "url": "http://s.senaidl.kr/PxLSd",
      "qr": "2026-h-1-1.png"
    },
    {
      "order": 2,
      "code": "c",
      "q_no": 10,
      "module": 2,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능의 예측 결과는 데이터의 한계로 인해 왜곡되거나 오류가 있을 수 있습니다. 따라서 제시된 답변을 수동적으로 수용하기보다, '출처와 근거가 타당한가?'를 비판적으로 검증하며 스스로 활용 여부를 결정해 보세요. 인공지능을 주도적으로 통제하고 판단하는 주체적인 태도가 무엇보다 중요합니다.",
      "study": "평소 인공지능 사용 습관을 점검하고, 비판력, 윤리성, 주체성 등 6가지 영역에서 부족한 부분을 찾아 나만의 가이드라인을 만들어봅니다. 퀴즈를 풀며, 인공지능을 주체적이고 지혜롭게 활용하는 능력을 기를 수 있습니다.",
      "url": "http://s.senaidl.kr/rl7kh",
      "qr": "2026-h-2-4.png"
    },
    {
      "order": 3,
      "code": "d",
      "q_no": 5,
      "module": 1,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "진로 분야에서 인공지능을 도구로 삼아 발전하려면, 협업 과정을 주체적으로 기획해야 합니다. 관심 분야 탐색 시 '내 역량을 키우기 위해 인공지능을 어떤 순서로 활용하고, 어떤 역할을 맡길 것인가?'를 먼저 설계해 보세요. 인간 고유의 역할을 정의하고 기술과 능동적으로 협업하는 역량이 중요합니다.",
      "study": "기술 중심과 인간 중심의 인공지능 개발이 가져올 결과를 비교하며 그 차이를 탐구해 봅니다. 이를 통해 인간 중심의 인공지능이 필요한 이유를 알고, 이를 위해 필요한 인공지능 개발주기 요소들을 찾아봅니다.",
      "url": "http://s.senaidl.kr/6vdee",
      "qr": "2026-h-1-5.png"
    },
    {
      "order": 4,
      "code": "c",
      "q_no": 6,
      "module": 1,
      "module_no": 6,
      "allCorrect": false,
      "feedback": "인공지능을 책임감 있게 사용하려면 지켜야 할 윤리 원칙이 있어요. 공정성, 신뢰성, 안전성, 투명성 같은 원칙은 상황마다 더 중요하게 작용하는 것이 달라요. 어떤 상황에서 어떤 원칙이 필요한지 따져 보면, 인공지능을 윤리적으로 판단하고 활용하는 힘을 기를 수 있어요.",
      "study": "인공지능 윤리 원칙과 편향성 카드를 제작한 뒤, 관련 기사를 찾아 원칙과 연결합니다. 매칭 결과를 분석해 어떤 분야에서 윤리 원칙이 미흡한지와 반복되는 문제를 탐구하며 비판적으로 성찰합니다.",
      "url": "http://s.senaidl.kr/LpKhp",
      "qr": "2026-h-1-6.png"
    },
    {
      "order": 5,
      "code": "d",
      "q_no": 25,
      "module": 5,
      "module_no": 6,
      "allCorrect": false,
      "feedback": "인간과 인공지능은 강점이 다르므로, 상호 보완적인 역할 분담을 주도적으로 설계해야 합니다. 협업을 진행할 때는 '내가 발휘해야 할 창의성과 윤리적 결정은 무엇이며, AI에게 맡길 데이터 분석은 무엇인가?'를 먼저 판단해 보세요. 각자의 강점을 파악하고 협업을 조율하는 주체적인 역량이 중요합니다.",
      "study": "기술 중심과 인간 중심의 인공지능 개발이 가져올 결과를 비교하며 그 차이를 탐구해 봅니다. 이를 통해 인간 중심의 인공지능이 필요한 이유를 알고, 이를 위해 필요한 인공지능 개발주기 요소들을 찾아봅니다.",
      "url": "http://s.senaidl.kr/6vdee",
      "qr": "2026-h-5-6.png"
    },
    {
      "order": 6,
      "code": "c",
      "q_no": 4,
      "module": 1,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능의 편향된 결과는 치우친 데이터에서 비롯됩니다. 이를 해결하려면 시스템의 출력을 맹신하지 말고, '데이터에 어떤 불균형이나 고정관념이 숨어 있는가?'를 주체적으로 파악해 보세요. 편향의 원인을 분석하고 다양한 관점이 반영되도록 조정하는 노력을 통해 공정한 AI 활용 능력을 기를 수 있습니다.",
      "study": "본 활동은 필터버블을 진단·치료하는 활동입니다. 시뮬레이션으로 수익 추구 알고리즘의 위험을 체험하고 다각적 해결책을 모색합니다. 추천 원리를 비판적으로 이해하고 AI 디지털 윤리의 사회적 영향을 깨닫는 것을 목표로 합니다.",
      "url": "http://s.senaidl.kr/BdTJS",
      "qr": "2026-h-1-4.png"
    },
    {
      "order": 7,
      "code": "a",
      "q_no": 17,
      "module": 4,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "자율주행 자동차는 센서로 주변을 인식하고, 그것이 보행자인지 판단한 뒤, 멈추거나 속도를 줄이는 행동을 해요. 인식 → 판단 → 행동으로 이어지는 과정을 순서도로 정리해 보면, 인공지능이 복잡한 상황을 어떻게 단계적으로 처리하는지 이해할 수 있어요.",
      "study": "자율주행 자동차를 중심으로 인공지능이 판단을 내리는 기초 규칙과 작동 프로세스를 이해하는 활동입니다. 코드를 실행해보며 '인지-판단-제어'로 이어지는 AI 알고리즘의 세부 단계를 파악하고, 실생활의 문제를 해결하는 기술적 탐구 능력을 기를 수 있습니다.",
      "url": "https://sai.software.kr/high/project/4809a400-459a-429a-bcc8-4d452f6d0194/report?act=activity2",
      "qr": "2026-h-4-2.png"
    },
    {
      "order": 8,
      "code": "c",
      "q_no": 24,
      "module": 5,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "수업에서 생성형 인공지능을 활용할 때는 먼저 그것이 목적에 맞는지, 언제 어떻게 쓸지 스스로 판단해야 해요. 인공지능이 만든 결과물을 그대로 제출하기보다, 사실인지 확인하고 내 생각을 더해 검토·수정하며 활용하는 것이 중요해요. 이렇게 주체적으로 사용하면 인공지능을 진짜 내 학습의 도구로 삼을 수 있어요.",
      "study": "간단하게 읽을 수 있는 카드뉴스를 통해 내 희망 진로 분야에서 사용되는 인공지능 기술에 대해 직접 조사해보고 작성해보며, 내 진로와 인공지능 사이의 미래에 대해 생각해봅니다.",
      "url": "http://s.senaidl.kr/DNvuD",
      "qr": "2026-h-5-5.png"
    },
    {
      "order": 9,
      "code": "b",
      "q_no": 23,
      "module": 5,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능을 능동적으로 활용하려면 결과물의 아쉬운 점이나 한계를 파악하는 태도가 필요해요. 앞으로는 도구를 사용하며 '어떤 기능이 더 보완되면 좋을까?'를 함께 고민해 보세요. 기술의 한계를 이해하고 개선 방향을 제안해 보는 과정이 주도적인 AI 사용자로 성장하는 데 중요합니다.",
      "study": "AI 활용 창작 콘텐츠의 검토 및 개선 방법을 만화를 통해 학습합니다. 이후 활동지 답안 작성을 통해 AI 창작물의 향상 방안을 이해할 수 있습니다.",
      "url": "http://s.senaidl.kr/OkkJy",
      "qr": "2026-h-5-4.png"
    },
    {
      "order": 10,
      "code": "c",
      "q_no": 19,
      "module": 4,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능이 일으키는 윤리적 딜레마는 정답이 하나로 정해져 있지 않아요. 같은 문제라도 개발자, 사용자, 기업, 사회처럼 이해관계자마다 입장과 이익이 다르기 때문이에요. 여러 관점을 함께 살펴보면, 누구의 어떤 가치가 부딪히는지 이해하고 균형 잡힌 판단을 내릴 수 있어요.",
      "study": "가상 AI 가짜 뉴스 사례로 기술의 위험성을 다룹니다. 팩트체크와 책임 소재를 분석하고 법적 사례와 비교하며 사회적 책임을 인지합니다. 이를 통해 올바른 정보 생산을 위한 '나만의 직업윤리'를 확립하는 것을 목표로 합니다.",
      "url": "http://s.senaidl.kr/j8SAI",
      "qr": "2026-h-4-4.png"
    },
    {
      "order": 11,
      "code": "a",
      "q_no": 16,
      "module": 4,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "인공지능 모델은 학습에 사용한 데이터에 따라 성능이 크게 달라져요. 풀려는 문제와 관련 있고 품질이 좋은 데이터를 골라야 모델이 제대로 학습해요. 어떤 데이터가 왜 필요한지 설명할 수 있으면, 좋은 인공지능을 만드는 기초를 갖추게 돼요.",
      "study": "기계학습을 이용한 문제 해결의 필요성과 전체 과정을 이해하는 활동입니다. 카드 뉴스를 통해 기계 학습을 큰 틀에서 이해하고, 기계학습 각 단계의 세부 내용과 유의 사항을 파악할 수 있습니다.",
      "url": "http://s.senaidl.kr/WjLtx",
      "qr": "2026-h-4-1.png"
    },
    {
      "order": 12,
      "code": "d",
      "q_no": 13,
      "module": 3,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "더 나은 사회를 위한 인공지능도 성능이 정확해야 제 역할을 할 수 있어요. 그러려면 예측에 실제로 영향을 주는 핵심 속성을 골라 학습시키는 것이 중요해요. 어떤 속성이 모델의 성능을 높이는지 따져 보면, 목적에 맞게 인공지능을 설계하는 힘을 기를 수 있어요.",
      "study": "인간 중심 AI의 핵심 가치를 이해하고, 기술이 인류의 공동선에 기여하기 위한 윤리적 기준을 탐색합니다. 사회적 가치와 다양성을 존중하는 AI 설계의 원칙을 파악하고, 인간의 존엄성을 지키면서 기술과 공존하는 미래 사회의 모습을 전망해봅니다.",
      "url": "https://www.youtube.com/watch?v=2-UZUlO9jAk",
      "qr": "2026-h-3-3.png"
    },
    {
      "order": 13,
      "code": "a",
      "q_no": 22,
      "module": 5,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "같은 인공지능이라도 어떻게 질문하느냐에 따라 답의 질이 달라져요. 구체적인 정보와 맥락, 원하는 형식을 담아 요청하면 훨씬 정확하고 쓸모 있는 결과를 얻을 수 있어요. 효과적인 프롬프트 전략을 익히면 생성형 인공지능을 똑똑하게 활용할 수 있어요.",
      "study": "같은 질문이라도 프롬프트에 따라 생성형 인공지능의 대답이 달라질 수 있음을 탐색하는 활동입니다. 서로 다른 프롬프트와 결과를 비교하며, 효과적인 질문의 특징을 이해할 수 있습니다.",
      "url": "http://s.senaidl.kr/q8UU0",
      "qr": "2026-h-5-3.png"
    },
    {
      "order": 14,
      "code": "b",
      "q_no": 20,
      "module": 5,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "생성형 인공지능의 답변은 그럴듯해도 틀릴 수 있어요. 앞으로 인공지능을 쓸 때는 결과를 바로 믿기보다 '이 정보가 정말 사실일까?'라는 의문을 갖고 비판적으로 검토해 보세요. 답변의 신뢰성을 스스로 평가하고 판단 근거를 찾아보는 연습이 중요합니다.",
      "study": "실생활 궁금증 해결과 손글씨 인식 기능을 활용해 능동적으로 질문하고 학습하는 방법을 익힙니다. AI와 디지털 도구로 교과 개념을 이해하고 일상 속 호기심을 직접 해결하며, 스스로 탐구하고 지식을 확장하는 자기주도적 학습 태도를 기를 수 있습니다.",
      "url": "http://s.senaidl.kr/ZZWkl",
      "qr": "2026-h-5-1.png"
    },
    {
      "order": 15,
      "code": "a",
      "q_no": 9,
      "module": 2,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "의사결정트리는 조건에 따라 가지를 따라가며 결론에 이르는 기계학습 모델이에요. 각 단계의 질문에 답하며 경로를 따라가면, 인공지능이 어떤 기준으로 판단을 내리는지 한눈에 볼 수 있어요. 이 과정을 이해하면 인공지능의 결정 과정을 설명할 수 있게 돼요.",
      "study": "두 변수 사이의 관계를 파악하기 위한 방법을 배우는 활동입니다. 데이터의 시각화를 통해 관계의 특성을 파악하거나, 수치화된 지표를 통해 두 변수 사이의 관계를 해석합니다.",
      "url": "http://s.senaidl.kr/chhpy",
      "qr": "2026-h-2-3.png"
    },
    {
      "order": 16,
      "code": "a",
      "q_no": 11,
      "module": 3,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "지능형 에이전트는 주변 환경을 인식하고(인식), 정보를 분석해 판단한 뒤(추론·판단), 그 결과에 따라 행동을 바꿔요(조절). 이 처리 과정을 순서대로 연결해 보면, 단순한 자동화와 달리 인공지능이 어떻게 지능적으로 작동하는지 이해할 수 있어요.",
      "study": "인간과 협력하는 AI 에이전트를 살펴봅니다. 학습과 업무 등 일상 전반에서 주도적으로 문제를 해결하는 지능형 에이전트의 특징을 이해하고 미래 사회 변화를 예측할 수 있습니다.",
      "url": "https://www.youtube.com/watch?v=2LE82uZ6rf0",
      "qr": "2026-h-3-1.png"
    },
    {
      "order": 17,
      "code": "a",
      "q_no": 12,
      "module": 3,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "기계학습의 핵심 원리는 사람이 규칙을 일일이 알려주는 대신, 인공지능이 많은 데이터를 보고 스스로 패턴과 규칙을 찾아내는 거예요. 이 원리를 이해하면 정해진 규칙대로만 작동하는 기존 프로그램과 무엇이 다른지 분명하게 알 수 있어요.",
      "study": "기계학습을 이용한 문제 해결의 필요성과 전체 과정을 이해하는 활동입니다. 카드 뉴스를 통해 기계 학습을 큰 틀에서 이해하고, 기계학습 각 단계의 세부 내용과 유의 사항을 파악할 수 있습니다.",
      "url": "http://s.senaidl.kr/WjLtx",
      "qr": "2026-h-3-2.png"
    },
    {
      "order": 18,
      "code": "b",
      "q_no": 18,
      "module": 4,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "인공지능·디지털 도구는 과목과 학습 상황에 따라 활용하는 방법이 달라져요. 글쓰기, 수학 풀이, 자료 탐색처럼 과제 유형마다 효과적인 도구가 다르기 때문이에요. 다양한 적용 사례를 살펴보면 내 공부에 어떤 도구를 어떻게 쓰면 좋을지 판단할 수 있어요.",
      "study": "실생활 궁금증 해결과 손글씨 인식 기능을 활용해 능동적으로 질문하고 학습하는 방법을 익힙니다. AI와 디지털 도구로 교과 개념을 이해하고 일상 속 호기심을 직접 해결하며, 스스로 탐구하고 지식을 확장하는 자기주도적 학습 태도를 기를 수 있습니다.",
      "url": "http://s.senaidl.kr/ZZWkl",
      "qr": "2026-h-4-3.png"
    },
    {
      "order": 19,
      "code": "c",
      "q_no": 14,
      "module": 3,
      "module_no": 4,
      "allCorrect": false,
      "feedback": "인공지능 서비스는 많은 개인정보를 수집하고 활용해요. 그래서 서비스를 쓰기 전에 어떤 정보가 수집되는지 확인하고, 보안과 권한 설정을 꼼꼼히 점검하는 습관이 필요해요. 이렇게 설정을 관리하면 나뿐 아니라 다른 사람의 정보까지 안전하게 보호할 수 있어요.",
      "study": "인공지능이 전세계적으로 보급되면서 인공지능 사용에 수반될 수 있는 여러 가지 부작용을 법적 측면, 개인정보 측면, 환경 측면에서 알아보고 그에 대한 의견을 정리해봅니다.",
      "url": "http://s.senaidl.kr/u1LAV",
      "qr": "2026-h-3-4.png"
    },
    {
      "order": 20,
      "code": "d",
      "q_no": 15,
      "module": 3,
      "module_no": 5,
      "allCorrect": false,
      "feedback": "인공지능 설계 시에는 개발 제안들이 인권과 공정성 등 인간 중심 가치에 부합하는지 비판적으로 검증해야 합니다. 각 제안을 검토하며 '이 기술이 공동선의 가치에 알맞은가?'를 따져보고 채택 여부를 주도적으로 판단해 보세요. 가치를 기준으로 기술을 평가하고 분류하는 주체적인 안목이 중요합니다.",
      "study": "인간 중심 AI의 핵심 가치를 이해하고, 기술이 인류의 공동선에 기여하기 위한 윤리적 기준을 탐색합니다. 사회적 가치와 다양성을 존중하는 AI 설계의 원칙을 파악하고, 인간의 존엄성을 지키면서 기술과 공존하는 미래 사회의 모습을 전망해봅니다.",
      "url": "https://www.youtube.com/watch?v=2-UZUlO9jAk",
      "qr": "2026-h-3-5.png"
    },
    {
      "order": 21,
      "code": "b",
      "q_no": 2,
      "module": 1,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "생성형 인공지능이 만든 결과물을 그대로 쓰는 것이 항상 좋은 것은 아니에요. 내가 원하는 목적과 맞는지 따져 보고, 그대로 받아들일지·고칠지·거부할지 판단하는 과정이 필요해요. 그 판단의 이유까지 설명할 수 있으면, 인공지능을 잘 활용하는 창작자가 될 수 있어요.",
      "study": "자신이 이용하거나 생성한 콘텐츠의 타당성을 체크리스트를 통하여 판단해 볼 수 있습니다. 프롬프트를 수정하여 이를 보완하는 과정을 거치며 콘텐츠의 타당도를 높일 수 있는 방법을 탐구하여 AI · 디지털 도구의 올바른 사용을 돕습니다.",
      "url": "http://s.senaidl.kr/SIQVd",
      "qr": "2026-h-1-2.png"
    },
    {
      "order": 22,
      "code": "a",
      "q_no": 8,
      "module": 2,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "기계학습 모델은 풀려는 문제에 따라 골라야 해요. 값을 예측할 때, 비슷한 것끼리 묶을 때, 종류를 나눌 때 쓰는 모델이 각각 달라요. 문제의 목적에 맞는 모델을 선택해 학습시키면, 인공지능이 더 정확한 결과를 내도록 만들 수 있어요.",
      "study": "기계학습의 가장 기초 알고리즘인 선형회귀분석을 통해 구체적인 학습 과정을 이해하는 활동입니다. 카드 뉴스를 통해 학습 절차를 자세히 이해하고, 기계 학습 알고리즘의 특성을 파악하여 기초를 다질 수 있습니다.",
      "url": "http://s.senaidl.kr/9OvTW",
      "qr": "2026-h-2-2.png"
    },
    {
      "order": 23,
      "code": "b",
      "q_no": 7,
      "module": 2,
      "module_no": 1,
      "allCorrect": false,
      "feedback": "인공지능 예측 프로젝트는 체계적인 계획 수립이 무엇보다 중요합니다. '어떤 데이터를 수집하여 무엇을 예측할 것인가?'를 명확히 정의하고, 모델 학습과 검증까지의 단계를 정밀하게 설계해 보세요. 일련의 과정을 주도적으로 기획해 보는 경험은 AI 기반의 문제 해결 능력을 기르는 데 큰 도움이 됩니다.",
      "study": "이 학습 자료를 활용하여 학교와 지역사회에서 발생하는 다양한 문제 상황을 해결하기 위해 적절한 AI 도구를 탐색하고, 그 선택 이유를 논리적으로 설명해 보며 문제 해결력과 비판적 사고력을 기를 수 있습니다.",
      "url": "http://s.senaidl.kr/PxLSd",
      "qr": "2026-h-2-1.png"
    },
    {
      "order": 24,
      "code": "a",
      "q_no": 3,
      "module": 1,
      "module_no": 3,
      "allCorrect": false,
      "feedback": "기계학습은 데이터 속에서 비슷한 특징을 찾아 무리를 나누거나 결과를 예측해요. 여러 데이터를 모아 패턴을 분석하면 어떤 기준으로 분류되는지 알 수 있어요. 데이터로 무리를 나누는 과정을 이해하면 기계학습이 어떻게 판단하는지 더 쉽게 파악할 수 있어요.",
      "study": "기계학습을 이용한 문제 해결의 필요성과 전체 과정을 이해하는 활동입니다. 카드 뉴스를 통해 기계 학습을 큰 틀에서 이해하고, 기계학습 각 단계의 세부 내용과 유의 사항을 파악할 수 있습니다.",
      "url": "http://s.senaidl.kr/WjLtx",
      "qr": "2026-h-1-3.png"
    },
    {
      "order": 25,
      "code": "a",
      "q_no": 21,
      "module": 5,
      "module_no": 2,
      "allCorrect": false,
      "feedback": "생성형 인공지능은 입력하는 프롬프트에 따라 결과물이 크게 달라져요. 원하는 결과를 얻으려면 주제, 스타일, 조건 같은 요소를 구체적으로 조합해 프롬프트를 설계해야 해요. 여러 조합을 시도해 보면 의도한 결과물에 더 가깝게 만드는 방법을 익힐 수 있어요.",
      "study": "요청 사항에 따라 변화하는 결과물을 비교하고, 이에 어울리는 이미지와 음악을 직접 골라 기획안을 완성함으로써 AI를 도구로 활용해 자신의 아이디어를 구체화하는 능력을 기릅니다.",
      "url": "http://s.senaidl.kr/dFbSs",
      "qr": "2026-h-5-2.png"
    },
    {
      "order": 26,
      "code": "d",
      "q_no": null,
      "module": null,
      "module_no": 1,
      "allCorrect": true,
      "feedback": "인공지능은 우리 일을 도와주는 유용한 도구로, 잘 활용하면 삶이 훨씬 편리해집니다. 하지만 사용하기 전에 우리가 직접 해야 할 일과 인공지능에게 맡겨도 될 일을 잘 구분해야 합니다. 인공지능과 어떤 사이가 되는 것이 좋을지 한 번 곰곰이 생각해보세요.",
      "study": "기술 중심과 인간 중심의 인공지능 개발이 가져올 결과를 비교하며 그 차이를 탐구해 봅니다. 이를 통해 인간 중심의 인공지능이 필요한 이유를 알고, 이를 위해 필요한 인공지능 개발주기 요소들을 찾아봅니다.",
      "url": "http://s.senaidl.kr/6vdee",
      "qr": "2026-h-a-1.png"
    },
    {
      "order": 27,
      "code": "a",
      "q_no": null,
      "module": null,
      "module_no": 2,
      "allCorrect": true,
      "feedback": "인공지능의 개념과 원리를 잘 이해하고 있으며, 다양한 사례를 통해 인공지능이 어떻게 활용되는지 폭넓게 학습하였습니다. 앞으로도 인공지능의 발전과 활용 방안에 관심을 가지고 지속적으로 탐구해 보시기 바랍니다.",
      "study": "<생성형 AI와 우리 사회> 웹 앱은, AI의 양면성을 탐구하고, 윤리적 딜레마 속에서 책임 있는 선택을 연습합니다. 비판적 검증 태도로 건강한 디지털 생태계를 만드는 '스마트 시민'이 되어보세요.",
      "url": "http://s.senaidl.kr/3VD9A",
      "qr": "2026-h-a-2.png"
    },
    {
      "order": 28,
      "code": "c",
      "q_no": null,
      "module": null,
      "module_no": 3,
      "allCorrect": true,
      "feedback": "인공지능을 사용할 때 윤리적인 관점을 고려하며, 개인정보 보호와 공정한 AI 활용의 중요성을 잘 이해하고 있습니다. 앞으로도 인공지능을 안전하고 책임감 있게 사용하며, 이를 통해 더욱 발전된 사고력을 기를 수 있도록 노력해 보시기 바랍니다.",
      "study": "인공지능 사용 경험을 일기로 작성하고, 윤리성과 필요성, 대안 가능성을 점검한다. 이후 사용 전 생각할 기준을 정리해 카드뉴스로 제작한다.",
      "url": "http://s.senaidl.kr/axKP1",
      "qr": "2026-h-a-3.png"
    },
    {
      "order": 29,
      "code": "b",
      "q_no": null,
      "module": null,
      "module_no": 4,
      "allCorrect": true,
      "feedback": "인공지능이 생활 속에서 어떻게 사용되는지 깊이 이해하고 있으며, 이를 문제 해결에 적용하는 능력이 뛰어납니다. 앞으로는 다양한 인공지능 도구를 직접 활용해 보고, 이를 실생활과 학습에 적극적으로 적용해 보시길 바랍니다.",
      "study": "자신이 원하는 콘텐츠를 계획하고, 이를 생성하기 위한 프롬프트를 단계별로 작성하며 콘텐츠를 직접 생성해 볼 수 있습니다. 나만의 아이디어를 구체화하는 프롬프트 작성 활동을 통해 상상력을 발휘하여 더욱 창의적인 디지털 결과물을 만들어내는 능력을 기를 수 있습니다.",
      "url": "http://s.senaidl.kr/cytjI",
      "qr": "2026-h-a-4.png"
    }
  ]
};

export const EXPECTED_PERFORMANCE = {
  "e": {
    "4": [
      "AI 원리 및 데이터 분석을 깊이 이해하고 AI의 결과물을 비판적으로 평가할 수 있다.",
      "AI 도구의 장단점을 평가하여 문제 해결과 창작, 학습 및 탐구에 창의적으로 적용할 수 있다.",
      "AI의 사회적 영향을 조사하고, 주체적이고 책임 있는 사용을 적극 실천할 수 있다.",
      "AI를 협업 대상으로 인식하며, AI로 해결할 수 있는 지속 가능한 문제 정의에 주체적으로 참여할 수 있다."
    ],
    "3": [
      "기계학습을 체험하고 AI 사례를 구별하며 생성형 AI의 종류와 활용 사례를 설명할 수 있다.",
      "AI 도구 활용 문제 해결 과정을 탐색하고 AI 콘텐츠 제작을 체험하며 장단점을 구별할 수 있다.",
      "AI의 안전한 사용을 실천하고 주체적인 사용방법을 설명하며 AI의 이로움과 해로움을 구별할 수 있다.",
      "AI가 잘하는 일을 발견하고 AI와 협업하는 자세를 인식하며 지속 가능한 AI 활용 사례를 탐색할 수 있다."
    ],
    "2": [
      "생활 속 AI의 원리와 기계학습의 간단한 개념을 탐색할 수 있다.",
      "AI 도구의 활용 사례를 탐색하고 가장 기본적인 창작 사례를 찾아 설명할 수 있다.",
      "안전한 AI 사용을 위한 기본 규칙과 AI로 대체할 수 없는 일을 단순하게 설명할 수 있다.",
      "주변의 지속 가능한 사회를 위한 AI의 활용 사례를 탐색하고 AI가 잘하는 일을 찾아볼 수 있다."
    ],
    "1": [
      "AI 개념에 대한 이해와 AI인 것을 구별하는 것에 관심을 가진다.",
      "AI 도구 활용의 필요성을 인식하고 학습 및 창작 도구를 사용할 수 있다.",
      "안전한 AI를 위한 기본 규칙과 개인정보 보호의 중요성에 대한 인식을 확립할 수 있다.",
      "AI의 역할과 인간과의 협업 개념에 대한 호기심과 탐구 의지를 키울 수 있다."
    ]
  },
  "m": {
    "4": [
      "AI와 기계학습의 주요원리를 깊이 있게 이해하고, AI의 결과물을 비판적으로 검토 및 개선할 수 있다.",
      "일상생활과 학습 상황에서 적절한 AI 도구를 선택하고 활용하여 문제를 해결하고, 깊이 있게 학습할 수 있다.",
      "AI의 사회적 영향을 균형있게 이해하고, 개인과 타인의 안전을 보호하며 AI를 주체적으로 활용할 수 있다.",
      "지속 가능한 AI를 설계하고, 의사결정의 주도권을 유지하며 AI와 효과적으로 협업할 수 있다."
    ],
    "3": [
      "AI와 기계학습의 주요 원리를 설명하고, AI의 결과물을 비판적으로 검토 및 평가할 수 있다.",
      "AI 도구를 활용하여 실생활 문제와 학습문제를 해결하고, 다양한 유형의 창작물을 제작할 수 있다.",
      "AI의 사회적 영향력과 윤리적 쟁점을 다양한 관점에서 탐색하고, 안전하고 주도적으로 AI를 활용할 수 있다.",
      "지속 가능한 AI를 구상하고, AI와의 협업 과정에서 인간의 주체적인 역할을 탐색할 수 있다."
    ],
    "2": [
      "사례를 통해 AI와 기계학습의 주요원리를 설명하고, 생성형 AI의 결과물을 검토할 수 있다.",
      "일상생활과 학습 상황에서 AI도구를 활용한 문제해결 과정을 탐색하고, 다양한 결과물을 창작할 수 있다.",
      "AI 도구 활용과정에서 개인정보와 저작권을 보호하고, 의사결정의 주도권을 유지하는 방법을 설명할 수 있다.",
      "AI를 활용한 지속 가능한 문제해결에 참여하고, AI와의 협업 절차 및 방법을 탐색할 수 있다."
    ],
    "1": [
      "AI와 기계학습의 기본원리를 이해하고, AI 결과물을 검토할 필요성을 인식할 수 있다.",
      "일상생활과 학습 상황에서 AI 도구가 필요한 상황을 발견하고, AI 도구 사용방법 및 절차를 탐색할 수 있다.",
      "AI 기술 오남용의 위험성을 이해하고, 안전하고 책임감 있는 AI 활용 습관을 탐색할 수 있다.",
      "사례를 통해 AI가 지속 가능한 사회 발전에 활용될 수 있음을 이해하고, AI와의 간단한 협업을 할 수 있다."
    ]
  },
  "h": {
    "4": [
      "지능형 에이전트, 기계학습, 생성형AI 원리를 탐구하고, 결과를 비판적으로 해석할 수 있다.",
      "AI·디지털 도구를 학습과 창작에 주도적으로 활용하고, 그 과정과 결과를 비판적으로 성찰할 수 있다.",
      "AI·디지털 기술의 사회적·윤리적 쟁점을 다각도로 분석하고, 진로와 연계해 책임 있게 판단할 수 있다.",
      "인간 중심 가치를 바탕으로 AI와 주도적으로 협업하며, 지속 가능한 AI 시스템을 설계·평가할 수 있다."
    ],
    "3": [
      "기계학습과 생성형AI의 작동 원리를 탐구하고, 목적에 맞는 모델과 데이터를 평가할 수 있다.",
      "AI·디지털 도구로 문제해결과 창작 과정을 계획·수행하고, 결과물을 검토하여 개선할 수 있다.",
      "AI 윤리 원칙과 잠재적 한계를 이해하고, AI가 사회에 미치는 영향을 분석할 수 있다.",
      "지속 가능한 사회를 위한 AI·디지털 프로젝트를 계획·수행하고, 인간중심 가치를 반영할 수 있다."
    ],
    "2": [
      "기계학습과 생성형AI의 기본 원리를 설명하고, AI의 기능을 탐색할 수 있다.",
      "AI·디지털 도구를 활용해 문제 해결 과정을 계획하고, 수행할 수 있다.",
      "상황과 목적에 맞게 AI 사용 여부와 방법을 판단하고, AI 결과물의 신뢰성을 점검할 수 있다.",
      "인간과 AI가 협업해 역량을 증강하는 사례를 탐색하고, 그 방법을 이해할 수 있다."
    ],
    "1": [
      "AI와 기계학습의 기본 개념을 이해하고, 생활 속 AI 서비스 사례를 구별할 수 있다.",
      "AI·디지털 도구의 활용 사례를 탐색하고, 문제 해결 과정을 간단히 설명할 수 있다.",
      "AI 사용 시 개인정보 보호와 안전의 중요성을 이해하고, AI를 책임감 있게 활용할 수 있다.",
      "AI가 인간과 협업하는 대상이 될 수 있음을 이해하고, 인간의 감독 필요성을 인식할 수 있다."
    ]
  }
};

export const CLASS_STRENGTH_WEAKNESS = {
  "e": {
    "a": {
      "s": "일상생활 속 다양한 인공지능 사례에 높은 호기심을 보이며, 인공지능과 비인공지능을 명확히 구별할 수 있습니다. 특히 기계학습의 기초적인 개념과 데이터의 중요성을 이해하고, 텍스트나 이미지 등 데이터 유형에 따른 수집 및 분석 과정을 원활하게 수행합니다.",
      "w": "기계학습 및 딥러닝의 작동 원리나 생성형 AI의 결과물이 도출되는 주요 원리 등 기술적 하부 구조에 대한 이해도가 낮습니다. 이는 단순 체험 위주의 학습에 치중될 때 나타나는 특성으로, 알고리즘의 원리에 대한 단계별 탐구 학습이 보완되어야 합니다."
    },
    "b": {
      "s": "AI 디지털 도구를 활용하여 문자, 그림, 소리 등 다양한 형태의 콘텐츠를 창작하는 체험에 능숙하며, 이를 통해 자신의 아이디어를 새롭게 표현하려는 태도를 보입니다. 실생활의 문제를 해결하거나 학습 상황에서 적절한 도구를 선택해 활용하는 응용 능력이 우수합니다.",
      "w": "다양한 AI 디지털 도구의 장단점을 비교하여 객관적으로 평가하거나, 도구가 창작에 활용될 때의 가치를 분석하는 비판적 사고 능력이 부족합니다. 도구를 기능적으로만 사용하는 수준에 머무를 수 있어, 도구 활용의 결과에 대한 자기 성찰적 평가 교육이 필요합니다."
    },
    "c": {
      "s": "개인정보 보호의 중요성을 명확히 인지하고 있으며, 인공지능 사용 시 저작권 존중 및 타인의 안전 보호와 같은 책임감 있는 태도를 실천합니다. 인공지능 기술이 사회에 주는 이로움과 해로움을 파악하여 주체적으로 기술을 수용하려는 자세를 갖추고 있습니다.",
      "w": "인공지능 과의존 문제나 딥페이크와 같은 구체적인 윤리적 이슈에 대해 실제적인 대응 및 예방 수칙을 실천하는 데 어려움을 보입니다. 지식적으로는 윤리 규범을 인지하고 있으나 실제 디지털 환경에서의 실천력이 낮으므로, 사례 중심의 윤리적 문제 해결 훈련이 강화되어야 합니다."
    },
    "d": {
      "s": "인공지능을 단순한 도구가 아닌 새로운 협업 대상으로 인식하며, 인간과 인공지능의 차이(인식 및 학습 방식 등)를 비교 분석하려는 탐구심이 강합니다. 지속 가능한 사회 발전을 위해 인공지능이 기여할 수 있는 사례에 관심을 갖고 주체적으로 참여하려는 의지를 보입니다.",
      "w": "우리 주변에서 인공지능이 잘 수행할 수 있는 구체적인 문제를 정의하거나, 인간의 가치에 부합하는 인공지능 활용 아이디어를 글이나 도식으로 구체화하는 설계 능력이 다소 미흡합니다. 이는 인권, 사회 정의 등 추상적 가치와 기술을 연결 짓는 경험이 부족하기 때문으로, 인간 중심 설계 관점의 프로젝트 활동이 권장됩니다."
    }
  },
  "m": {
    "a": {
      "s": "예측·분석·추천·생성과 같은 AI의 역할과 주요 원리를 사례와 연결하여 설명할 수 있습니다. 특히 지도학습, 비지도학습, 강화학습 등 기계학습의 유형별 차이를 이해하고 있으며, 수집된 데이터를 직접 구조화하고 시각화하여 간단한 기계학습 모델을 스스로 제작하는 실천적 역량이 우수합니다.",
      "w": "생성형 AI의 기본 원리와 다른 AI 기술과의 차이점을 설명하는 데 어려움을 보입니다. 또한 학습 데이터의 편향이 AI 모델의 결과에 미치는 영향을 충분히 고려하지 못하는 경향이 있습니다. AI가 하는 일과 주요 원리, 데이터 수집 및 분석 과정이 AI 결과에 미치는 영향을 체계적으로 지도할 필요가 있습니다."
    },
    "b": {
      "s": "적절한 AI·디지털 도구를 활용하여 문제를 해결하고, 글, 이미지, 소리, 동영상 등 다양한 형태의 결과물을 창작할 수 있습니다. 또한 AI가 생성한 콘텐츠임을 명확히 표시하고, 저작권과 출처를 고려하여 책임감 있게 활용하는 습관을 갖추고 있습니다. AI·디지털 도구의 활용 과정을 성찰하고 평가할 수 있습니다.",
      "w": "일상생활과 다양한 분야에서 AI·디지털 기술을 활용한 문제해결 사례를 탐색하고 분석하는 능력이 다소 미흡합니다. 또한 AI의 결과물을 그대로 수용하는 모습을 보이기도 합니다. 일상생활과 학습 상황에서 적절한 AI·디지털 기술을 선택 및 활용하고, 결과물을 비판적으로 검토할 수 있도록 지도가 필요합니다."
    },
    "c": {
      "s": "AI·디지털 도구를 주체적이고 책임감 있게 사용하기 위한 자신만의 가이드라인을 만들고 실천할 수 있습니다. 개인정보 보호와 데이터 보호의 중요성을 알고, AI 결과를 윤리적 관점에서 검토하며, AI와 관련된 윤리적 문제를 예방하고 해결하려는 태도를 보입니다. 또한 AI와 관련된 직업에 관심을 갖고 자신의 진로와 연결해 탐색할 수 있습니다.",
      "w": "AI와 관련된 윤리적 딜레마에서 문제의 원인을 분석하고 해결 방안을 모색하는 데 어려움을 보입니다. 이는 단순 규범 암기를 넘어 AI의 사회적 영향을 고려한 토론과 사례 분석이 보완되어야 함을 시사합니다. 또한 AI·디지털 기술 사용 과정을 스스로 조절하며 책임감 있게 활용하는 방법에 대해서도 체계적인 교육이 필요합니다."
    },
    "d": {
      "s": "지속 가능한 사회 발전을 위해 AI로 해결할 수 있는 문제를 정의하고, AI를 활용한 문제해결 방법을 구상하고 이를 프로토타입으로 설계하는 역량이 돋보입니다. AI가 인간의 가치·목적·맥락에 부합하는지 비판적으로 검토하는 태도를 갖추고 있으며, AI와 협업하는 과정에서 의사결정의 주도권을 유지하며 효과적으로 협업할 수 있습니다.",
      "w": "지속 가능한 사회 발전을 위해 AI를 활용한 문제해결 사례를 탐색하고 분석하는 능력이 다소 미흡합니다. AI가 사회 정의나 포용성 등을 고려하여 설계되었는지 비판적으로 검토하는 시각을 기르는 교육이 필요합니다. 또한 일상과 학습상황에서 인간과 AI의 역할을 나누어 협업 전략을 세우고 실천하는 경험을 지원할 필요가 있습니다."
    }
  },
  "h": {
    "a": {
      "s": "지능형 에이전트의 개념과 기계학습의 다양한 유형 및 처리 과정을 이해하고 있습니다. 데이터의 출처, 편향, 품질 등을 검토하고, AI의 결과를 비판적으로 해석할 수 있습니다. 생성형 AI의 가능성과 한계를 파악하여 효과적인 프롬프트 전략을 구상하는 역량이 우수합니다.",
      "w": "지능형 에이전트와 기계학습의 기본 개념을 이해하는 데 어려움을 보입니다. 데이터의 출처나 품질을 검토하고, AI의 결과를 비판적으로 해석하는 자세를 길러야 합니다. 목적에 맞는 프롬프트 전략을 구상하는 역량을 갖추기 위해 생성형 AI의 가능성과 한계에 대한 이해를 넓혀가야 합니다."
    },
    "b": {
      "s": "다양한 AI 융합 사례 분석을 통해 문제를 정의하고 AI·디지털 도구로 해결 과정을 계획 및 수행할 수 있습니다. AI의 결과물을 비판적으로 검토하고 개선하여 창의적으로 표현하는 역량이 뛰어납니다. 학습 상황에 따라 적절한 AI·디지털 도구를 선택하고, 주도적으로 학습하는 태도가 우수합니다.",
      "w": "AI·디지털 도구를 활용하여 문제를 정의하고 해결하는 데 어려움을 보입니다. AI가 추천 및 생성한 결과물에 대해 비판적으로 검토하여 수용·수정·거부의 판단 근거를 마련하는 연습이 필요합니다. 학습 상황에 맞는 AI·디지털 도구를 선택하고, 주도적으로 학습하는 태도가 필요합니다."
    },
    "c": {
      "s": "상황과 목적에 맞게 적절한 AI·디지털 도구를 선택하여 활용할 수 있습니다. 편향, 필터버블 등 AI가 개인과 사회, 직업구조에 미치는 영향을 분석하고, 윤리적 딜레마의 원인을 다양한 관점에서 탐색할 수 있습니다.",
      "w": "상황과 목적에 따른 AI·디지털 도구의 활용 기준을 판단하는 데 어려움을 보이며, AI 결과물의 신뢰성과 윤리적 적절성을 스스로 검토 및 검증하는 연습이 필요합니다. AI의 발전이 사회와 직업 구조에 미치는 다각적인 영향을 이해하고, 이로 인한 윤리적 쟁점을 다양한 관점에서 탐색하는 자세가 필요합니다."
    },
    "d": {
      "s": "공동체의 지속 가능한 발전을 위해 문제를 정의하고, AI 기반 프로젝트를 계획 및 수행할 수 있습니다. AI 개발과 활용 과정에서 인간 중심의 가치와 안전을 고려하며, AI가 인간의 가치와 목적에 부합하는지 비판적으로 평가하고, 지속 가능한 AI 생태계에 기여하려는 태도가 돋보입니다.",
      "w": "공동체의 지속 가능한 발전을 위해 문제를 정의하고 AI 기반 프로젝트를 계획·수행하는 데 어려움을 보입니다. AI 활용 과정에서 인간 중심의 가치와 안전을 우선시하는 자세가 필요하며, AI의 결과물이 인간의 목적과 맥락에 부합하는지 비판적으로 평가하고 검토하는 태도를 길러야 합니다."
    }
  }
};

export const CLASS_ACHIEVEMENT_PHRASES = [
  {
    "min": 70,
    "text": "우수한"
  },
  {
    "min": 40,
    "text": "양호한"
  },
  {
    "min": 0,
    "text": "미흡한"
  }
];

export const FAMILY_RESOURCES = {
  "intro": {
    "e": "초등학교 시기는 AI·디지털 도구보다 직접적인 체험과 관계 속에서 배우는 것이 더 중요한 시기입니다. AI·디지털 도구는 학생의 호기심을 자극하고 배움을 확장하는 보조 수단으로 활용하되, 스스로 생각하고 탐구하는 경험이 중심이 되어야 합니다.",
    "m": "중학교 시기는 자아정체성이 형성되고 비판적 사고 능력이 본격적으로 발달하는 시기입니다. AI·디지털 도구는 학생 스스로 탐구하고 질문하는 힘을 키우는 방향으로 활용하되, 도구에 대한 의존보다 주체적인 활용 능력을 기르는 것이 중요합니다.",
    "h": "고등학교 시기는 진로와 학업이 긴밀히 연결되며, 학습의 과정과 결과를 함께 관리해야 하는 시기입니다. AI·디지털 도구는 심화 탐구와 자기주도 학습을 지원하는 도구로 활용하되, 결과를 그대로 수용하기보다 근거를 검토하고 활용 범위를 투명하게 밝히는 태도가 중요합니다. 또한 입시·평가와 연결되는 학교급 특성을 고려하여 학문적 윤리, 개인 정보 보호, 공정한 평가 기준을 함께 갖추어야 합니다."
  },
  "student": {
    "e": "학생은 AI·디지털 도구를 그대로 따르는 것이 아니라, 스스로 생각하고 탐구하는 힘을 키워가는 주체입니다. 초등학교 시기에는 도구를 사용하기 전에 먼저 생각하는 습관, 어떻게 활용할지 계획하는 자세, 결과를 그대로 믿지 않고 확인하는 태도, 어디까지 도움을 받았는지 밝히는 자세를 배우는 것이 중요합니다.",
    "m": "학생은 AI·디지털 도구가 제공하는 결과를 맹목적으로 따르는 수동적인 소비자가 아닙니다. 목적에 맞게 도구를 선택하고, 정보의 진위를 검증하며, 최종 결과에 책임지는 주체적인 학습자입니다.",
    "h": "학생은 AI·디지털 도구가 제공하는 결과를 맹목적으로 따르는 수동적인 소비자가 아닙니다. 목적에 맞게 도구를 선택하고, 정보의 진위를 검증하며, 최종 결과에 책임지는 주체적인 학습자입니다."
  },
  "parent": {
    "e": "학부모는 자녀와 함께 디지털 세상을 탐험하고 대화하며 신뢰를 쌓는 파트너입니다. 초등학생은 스스로 사용 시간과 목적을 조절하는 능력이 아직 충분하지 않으므로, 보호자의 관심과 함께 건강한 활용 습관을 형성하는 것이 중요합니다. 스마트 디바이스를 무조건 금지하는 것 보다 '함께' 시작하는 것이 바람직합니다.",
    "m": "학부모는 자녀가 AI·디지털 도구를 책임감 있고 주체적으로 활용하도록 대화하며 돕는 든든한 조력자입니다. 기기 사용에 대한 과도한 간섭보다는 스스로 조절하는 능력을 키울 수 있도록 지원합니다.",
    "h": "학부모는 자녀의 AI·디지털 도구의 활용 과정에서 학습 주도성과 디지털 윤리를 함께 길러주는 동반자입니다. 특히 고등학교에서는 성과 중심(점수·스펙 등)으로 인해 무분별한 정보 의존 위험이 커질 수 있으므로, 가정에서는 '이해-대화-성찰'의 구조로 교육적 활용 문화를 함께 만들어가는 것이 중요합니다."
  },
  "reference": {
    "text": "자녀가 AI·디지털 도구를 주체적이고 안전하게 활용할 수 있도록 보호자가 알아야 할 핵심 가치와 실천 원칙, 학교급별 지도 방법을 안내합니다. 특히 가정에서 자녀와 함께 올바른 AI·디지털 활용 습관을 형성하고 학교 교육과 연계하여 지도할 수 있는 구체적인 방법을 제시합니다.",
    "url": "https://drive.google.com/file/d/1C9nZ4mPSd3FWhloPnoY2Mg4VVmgDpUVw/view"
  },
  "cards": [
    {
      "key": "AI·에듀테크",
      "text": "자녀가 AI·에듀테크를 올바르게 활용할 수 있도록 초·중·고 학교급별로 보호자가 실천할 수 있는 지도 방법과 활용 원칙을 안내합니다.",
      "url": "https://drive.google.com/file/d/1Ye14sGtHFrBZ86ni3sxjPrJ9mFOYElvK/view"
    },
    {
      "key": "디벗",
      "text": "자녀가 디벗을 안전하고 책임감 있게 활용할 수 있도록 기기·계정 관리 방법과 디지털 시민 에티켓을 안내합니다. 가정에서 함께 실천할 수 있는 디지털 생활 약속과 체크리스트를 제공합니다.",
      "url": "https://drive.google.com/file/d/1u-ArIjWMP_iWqBR97vy7pOnA4rTmpYc2/view?usp=drive_link"
    },
    {
      "key": "AI 교육",
      "text": "AI교육 브리핑'은 학생들이 AI 윤리와 디지털 시민성을 올바르게 함양할 수 있도록 안내하고, 생생한 AI·디지털 수업 교실 사례를 공유합니다.",
      "url": "https://sites.google.com/sonline20.sen.go.kr/seouldigitalnews?usp=sharing"
    },
    {
      "key": "디지털",
      "text": "함께 해보기(가족 활동)'와 '가족 전략(Family Tips) 실천' 등으로 구성된 활동을 통해 자녀들이 책임감 있고 안전한 디지털 시민으로 성장하도록 돕기 위한 가정용 가이드입니다.",
      "url": "https://buseo.sen.go.kr/buseo/bu10/user/bbs/BD_selectBbs.do?q_bbsSn=1240&q_bbsDocNo=20250828150901041"
    }
  ]
};

export const CLASS_TEACHING_RESOURCES = {
  "items": [
    {
      "area": "AI·디지털 기술",
      "title": "서울교육포털 – AI·SW교구 활용 수업자료 가이드북",
      "url": "https://www.ssem.or.kr/courseOrgider/edcDta/tutHpDta/cmmEdcDta/cmmEdcDtaView.do?dataSn=258288&courseDataSe=C&pageIndex=2&frmGubun=L&pageTy=list&moreSearchYn=&depth1=1&depth2=1&depth3=1&srhMclas=SCMC00&srhLclas=SCM&srhSclas=&viewCnt=12&srhGubun=A&srhKeyword=?dataSn=258288&courseDataSe=C&secKey=KUm%2FX5fvvLH5JQLmpQZFNlg255ibfUEuTA6EEkFQIPo%3D"
    },
    {
      "area": "AI·디지털 기술",
      "title": "한국과학창의재단 – AI교육 콘텐츠",
      "url": "https://sai.software.kr"
    },
    {
      "area": "AI·디지털 활용",
      "title": "서울특별시교육청교육연구정보원 – AI교육서비스 활용수업자료집",
      "url": "https://www.ssem.or.kr/viewer/skin/doc.html?fn=1738909832130.pdf&rs=/viewer/result/"
    },
    {
      "area": "AI·디지털 활용",
      "title": "KERIS – 생성형 AI를 활용한 교수학습 운영 가이드",
      "url": "https://keris.or.kr/main/ad/pblcte/selectPblcteETCInfo.do?mi=1142&pblcteSeq=13792"
    },
    {
      "area": "AI·디지털 윤리",
      "title": "서울시교육청 – AI윤리·디지털 시민성 교육자료",
      "url": "https://www.ssem.or.kr/viewer/skin/doc.html?fn=1756702754739.hwp&rs=/viewer/result/"
    },
    {
      "area": "AI·디지털 윤리",
      "title": "인공지능 윤리 소통채널 – 초·중·고 AI 윤리 교재",
      "url": "https://ai.kisdi.re.kr/aieth/bbs/B0000082/list.do?menuNo=400011"
    },
    {
      "area": "인간중심 AI 설계",
      "title": "서울특별시교육청 – AI·에듀테크 공교육 도입 및 활용 가이드라인",
      "url": "https://buseo.sen.go.kr/buseo/bu10/user/bbs/BD_selectBbs.do?q_bbsSn=1240&q_bbsDocNo=20251220202229742"
    },
    {
      "area": "인간중심 AI 설계",
      "title": "서울특별시교육청 – 독서기반 문해력 향상 자료집 <인간과 인공지능>",
      "url": "https://www.ssem.or.kr/api/intergrated/tutHpDta/metaSearch/apiBbs/apiBbsView.do?bbsDocNo=20250529101039648&bbsSn=1454"
    }
  ],
  "ecosystem": {
    "title": "서울특별시교육청 디지털 기반 교육생태계 도움자료",
    "url": "https://fliphtml5.com/bookcase/bucrw",
    "titleLines": [
      "서울특별시교육청",
      "디지털 기반",
      "교육생태계 도움자료"
    ]
  }
};

export const PRINCIPAL_LAST_PAGE = {
  "usage": [
    {
      "target": "학생·가정",
      "items": [
        {
          "area": "현재 수준 이해",
          "method": "개인별 점수와 성취 수준에 대한 정보를 통해 학생들은 자신의 현재 AI·디지털 리터러시 수준을 객관적으로 이해"
        },
        {
          "area": "학습 방향 설정",
          "method": "영역별 정답률을 통해 자신의 우수한 영역과 취약한 영역을 파악하고 향후 스스로 보완해야 할 학습 방향성 설정에 활용"
        },
        {
          "area": "맞춤형 자기주도 학습",
          "method": "결과지에 제공된 영역별 학습 조언과 추천 학습 자료를 활용하여 자기주도적 맞춤형 학습 실천"
        },
        {
          "area": "가정 연계 학습",
          "method": "자녀의 AI·디지털 리터러시 수준을 파악하고, 가정 연계 학습 자료를 통해 가족 구성원이 함께 학습에 참여하며 올바른 AI·디지털 활용 습관 형성"
        }
      ]
    },
    {
      "target": "교사",
      "items": [
        {
          "area": "수준별 지도 계획",
          "method": "학급 학생들을 성취 수준에 따라 분류하고 수준별 학생 비율과 명단을 활용하여, 세심한 지도가 필요한 학생을 위한 맞춤형 교육 계획 수립"
        },
        {
          "area": "학급 특색 지도",
          "method": "학급과 학교 평균의 비교 분석을 통해 우리 학급만의 강점과 약점을 파악하고, 학급 특색에 맞는 지도 계획 수립"
        },
        {
          "area": "수업 설계 반영",
          "method": "학급 내 낮은 영역을 분석하여 학생들의 수업계획에 활용"
        }
      ]
    },
    {
      "target": "학교",
      "items": [
        {
          "area": "교육과정 반영",
          "method": "학교 전체의 종합적인 성취 경향성을 파악하여 학교 AI·디지털 기반 교육과정의 내실을 검증하고, 결과 데이터를 교육목표 및 학교 교육계획에 반영"
        },
        {
          "area": "교육 성장 지원",
          "method": "학급 간 비교 분석을 통해 학교 내 균형에 있는 교육성장을 위하여 학급별 맞춤형 지원과 교육 자원을 효율적으로 분배"
        }
      ]
    }
  ],
  "resources": [
    {
      "title": "서울시교육청 「초·중·고 AI 교육 종합계획」",
      "url": "https://buseo.sen.go.kr/buseo/bu10/user/bbs/BD_selectBbs.do?q_bbsSn=1240&q_bbsDocNo=20251224174401724"
    },
    {
      "title": "AI에듀테크 공교육 도입 및 활용 가이드라인",
      "url": "https://buseo.sen.go.kr/buseo/bu10/user/bbs/BD_selectBbs.do?q_bbsSn=1240&q_bbsDocNo=20251220202229742"
    },
    {
      "title": "AI 윤리·디지털 시민성 교육자료",
      "url": "https://www.ssem.or.kr/viewer/skin/doc.html?fn=1756702754739.hwp&rs=/viewer/result/"
    },
    {
      "title": "AI·디지털 기반 교육생태계 도움자료",
      "url": "https://onlinebooks.co.kr/bookcase/bucrw/"
    }
  ]
};

